<template>
  <div>
    <!-- begin :: Web -->
    <div v-if="$objBaseInfo.channelId === 'WEB'" class="detail_room_list">
      <div style="margin: 20px 0; display: flex; justify-content: flex-start;gap: 20px;" v-if="(!$objBaseInfo.onlyShowBestPrice || $objBaseInfo.sourceType === 'CRM')">
        <div>
          <el-checkbox-group v-model="filterGroup" size="large" style="margin-left: 1rem" :disabled="showFilter">
            <el-checkbox-button v-for="filter in filterList" :label="filter.value" :key="filter.value" @change="filterChange">{{filter.label[$t('COMMONPARAM.RESPONSEDATA.SHOWTYPE')]}}</el-checkbox-button>
          </el-checkbox-group>
        </div>
        <div>
          <el-select class="payment" v-model="priceAreaValue" size="large" :placeholder="$t('RESULT.PRICERANGE')" :disabled="showFilter">
                <el-option v-for="item in priceRangeOptions" :key="item.value" :label="item.label[$t('COMMONPARAM.RESPONSEDATA.SHOWTYPE')]" :value="item.value" @click="handlePriceRangeChange(item.value)">
            </el-option>
          </el-select>
        </div>
      </div>
      <!-- <Loading :loading="loading" /> -->
      <!-- 子组件确认框  confirmMsg 提示内容-->
      <ConfirmBoxs :centerDialogVisible="confirmFlag" :confirmMsg="confirmMsg" :icon="confirmIcon" @setConfirmFlag="setConfirmFlag"></ConfirmBoxs>
      <el-row class="detail_list_title_ul">
        <el-col :span="4" class="table-title">{{ $t("DETAIL.ROOMTYPE") }}</el-col>
        <el-col :span="20">
            <el-row>
            <el-col :span="3" class="table-title">{{ $t("DETAIL.SLEEPS") }}</el-col>
            <el-col :span="3" class="table-title">{{ $t("DETAIL.BEDTYPE") }}</el-col>
            <el-col :span="3" class="table-title">{{ $t("DETAIL.BREAKFAST") }}</el-col>
            <el-col :span="2" class="table-title">{{ $t("DETAIL.FACILITES") }}</el-col>
            <el-col :span="4" class="table-title">{{ $t("DETAIL.POLICY") }}</el-col>
            <el-col :span="4" class="table-title">{{ $t("DETAIL.PAYMENTTYPE") }}</el-col>
            <el-col :span="5" class="table-title"></el-col>
            </el-row>
        </el-col>
      </el-row>

      <div class="room_list">
        <div class="no_List" v-if="showTag"> {{ $t("DETAIL.NOMORETITLE") }}</div>
        <el-row class="room_list_item" v-for="(item, index) in originData" :key="index">
          <el-col :span="4" class="room_panel" v-if="item.ratePlans.length >0">
            <div class="room_pic">
              <img style="width:100%; height:100%" :src="item.roomDescriptiveInfo.photos[0]? item.roomDescriptiveInfo.photos[0]: require('@/assets/img/room_img_error.png')" :onerror="defaultImgRoom" alt="defaultImgRoom" @click="showViewImage(item)" />
            </div>
            <div class="room_name">{{$i18n.locale == "en" ? (item.roomDescriptiveInfo.name.en ? item.roomDescriptiveInfo.name.en :'N/A') : (item.roomDescriptiveInfo.name['zh-CN'] ? item.roomDescriptiveInfo.name['zh-CN'] : '暂无数据')  }}</div>
            <!-- <div class="room_name room_name_Inter" v-if="$objBaseInfo.destinationType == 'I'" :title="item.roomDescriptiveInfo.description">{{item.roomDescriptiveInfo.description}}</div> -->
            <div class="room_view main_link_tab" @click="showViewImage(item)">
              {{ $t("DETAIL.VIEW") }}
            </div>
          </el-col>
          <el-col :span="20">
            <div class="saleroomlist_box box_border" v-for="(list, index) in item.ratePlans" :key="index">
              <el-row class="saleroomlist_dec">
                <el-col :span="3">
                  <div class="saleroomlist_dec_icon">
                    <!-- 屏幕阅读器可读但视觉隐藏的文本 -->
                    <span class="visually-hidden">{{ $t("DETAIL.GUEST", item.roomDescriptiveInfo.maximumOccupancy, { bedCount: item.roomDescriptiveInfo.maximumOccupancy }) }}</span>
                    
                    <div v-if="item.roomDescriptiveInfo.maximumOccupancy < 3">
                      <svg-icon 
                        v-for="(_, index) in item.roomDescriptiveInfo.maximumOccupancy" 
                        :key="index" 
                        icon-class="guest" 
                        class-name="detail_icon"
                        aria-hidden="true"
                      ></svg-icon>
                    </div>
                    <div v-else>
                      <svg-icon 
                        icon-class="guest" 
                        class-name="detail_icon"
                        aria-hidden="true"
                      ></svg-icon>
                      <span aria-hidden="true"> X {{item.roomDescriptiveInfo.maximumOccupancy}}</span>
                    </div>
                  </div>
                </el-col>
                <el-col :span="3">
                  <div>
                    <strong>
                      {{ getBedCode(item.roomDescriptiveInfo.bedTypeCode) }}
                    </strong>
                  </div>
                </el-col>
                <el-col :span="3">
                  <div>{{ list.breakfastInfo.quantity == 0 ? $t("DETAIL.linshi2"):( list.breakfastInfo.quantity == 99 ? $t("DETAIL.HASBREAKFAST") : $t("DETAIL.BREAKFAST") + ' '+'x'+' ' + list.breakfastInfo.quantity) }}</div>
                </el-col>
                <el-col :span="2">
                  <div>
                    <el-tooltip v-if="ShowWindow(item)" :content="$t('COMMONPARAM.WINDOW.WINDOW0')" placement="top" effect="light">
                      <svg-icon icon-class="Non-window" className="detail_icon"></svg-icon>
                    </el-tooltip>
                  </div>
                  <div>
                    <el-tooltip v-if="item.roomDescriptiveInfo.hasWindow == 1" :content="$t('COMMONPARAM.WINDOW.WINDOW1')" placement="top" effect="light">
                      <svg-icon icon-class="window" className="detail_icon"></svg-icon>
                    </el-tooltip>
                    <el-tooltip v-if="item.roomDescriptiveInfo.hasWindow == 2" :content="$t('COMMONPARAM.WINDOW.WINDOW2')" placement="top" effect="light">
                      <svg-icon icon-class="window" className="detail_icon"></svg-icon>
                    </el-tooltip>
                    <el-tooltip v-if="item.roomDescriptiveInfo.hasWindow == 3" :content="$t('COMMONPARAM.WINDOW.WINDOW3')" placement="top" effect="light">
                      <svg-icon icon-class="window" className="detail_icon"></svg-icon>
                    </el-tooltip>
                    <el-tooltip v-if="item.roomDescriptiveInfo.hasWindow == 4" :content="$t('COMMONPARAM.WINDOW.WINDOW4')" placement="top" effect="light">
                      <svg-icon icon-class="window" className="detail_icon"></svg-icon>
                    </el-tooltip>
                    <el-tooltip v-if="item.roomDescriptiveInfo.hasWindow == 5" :content="$t('COMMONPARAM.WINDOW.WINDOW5')" placement="top" effect="light">
                      <svg-icon icon-class="window" className="detail_icon"></svg-icon>
                    </el-tooltip>
                    <el-tooltip v-if="item.roomDescriptiveInfo.hasWindow == 6" :content="$t('COMMONPARAM.WINDOW.WINDOW6')" placement="top" effect="light">
                      <svg-icon icon-class="window" className="detail_icon"></svg-icon>
                    </el-tooltip>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="policy-content">
                    <div v-if="list.priceType != 0 && list.channelDescription!=null">
                      {{ list.channelDescription[$t('COMMONPARAM.RESPONSEDATA.SHOWTYPE')] }}
                    </div>
                    <div v-if="list.priceType == 0 && !list.priceOwner =='' ">
                      {{list.priceOwner =='cwt'? $t("DETAIL.CWTPRICE") : $t("DETAIL.CLIENTPRICE")+ChainwidePrice(list)}}
                    </div>
                    <div v-if="list.isGuaranteeRequired">
                      {{GetGuaranteeText(list) }}
                      <el-tooltip v-if="GetGuaranteeTooltip(list)!=''" :content="GetGuaranteeTooltip(list)" placement="top" effect="light">
                        <svg-icon icon-class="exclamation" style="vertical-align: -0.5em;"></svg-icon>
                      </el-tooltip>
                    </div>
                    <div v-if="(list.bookingType == 'normal')">
                      {{ $t("DETAIL.INSTANT") }}
                    </div>
                    <div v-if="(list.bookingType == 'bur')" class="delayClass">
                      {{ $t("DETAIL.DELAY") }}
                    </div>
                    <div v-if="(list.cancellationPolicy == 0)">
                      {{ $t("DETAIL.CANCELLATIONPOLICY0")}}
                    </div>
                    <div v-if="(list.cancellationPolicy == 1)">
                      {{ $t("DETAIL.CANCELLATIONPOLICY1")}}
                    </div>
                    <div v-if="(list.cancellationPolicy == 2)">
                      {{ $t("DETAIL.CANCELLATIONPOLICY2")}}
                    </div>
                    <div v-if="(list.isIntegral==true)">
                      {{ $t("DETAIL.LoyaltyPoints") }}
                    </div>
                    <div v-if="(list.isIntegral==false)">
                      {{ $t("DETAIL.NoLoyaltyPoints") }}
                    </div>
                  </div>
                </el-col>
                <el-col :span="4" class="li-payment">
                  <!--CRM时显示资源方-->
                  <div v-if="pathSource == 'CRM'" style="margin-bottom: 1rem">
                    {{ list.source }}
                  </div>
                  <div style="text-align: -webkit-center" v-show="list.paymentType == 1 ">
                    <div class="li-payment-item bottom">
                      {{ $t("DETAIL.PAYMENTTYPE1") }}
                    </div>
                  </div>
                  <div style="text-align: -webkit-center" v-show="list.paymentType == 2 ">
                    <div class="li-payment-item bottom">
                      {{ $t("DETAIL.PAYMENTTYPE2") }}
                    </div>
                  </div>
                  <div style="text-align: -webkit-center" v-show="list.paymentType == 3 ">
                    <div class="li-payment-item bottom">
                      {{ $t("DETAIL.PAYMENTTYPE3") }}
                    </div>
                  </div>
                </el-col>
                <el-col :span="5" style="text-align: right" class="li_view">
                  <div v-if="$objBaseInfo.showTravelTitle && $objBaseInfo.displayTravelRules">
                    <div v-if="$objBaseInfo.hotelBookingRole ==1 && list.isOutOfPolicy === true && $objBaseInfo.policySwitch && $objBaseInfo.personalizationPolicySwitch && $objBaseInfo.personalizationPolicyInfo && $objBaseInfo.personalizationPolicyInfo.descCn">
                      <el-tooltip :content="$i18n.locale === 'en' && $objBaseInfo.personalizationPolicyInfo && $objBaseInfo.personalizationPolicyInfo.descEn ? $objBaseInfo.personalizationPolicyInfo.descEn : ($objBaseInfo.personalizationPolicyInfo && $objBaseInfo.personalizationPolicyInfo.descCn ? $objBaseInfo.personalizationPolicyInfo.descCn : '')" OUTOFPOLICYTIPplacement="bottom" effect="light">
                        <div class="policy_outof_in policy_outof_color">
                          {{ $t("MESSAGE.OUTOFPOLICY") }}
                        </div>
                      </el-tooltip>
                    </div>
                    <div v-else>
                      <el-tooltip :disabled="!$objBaseInfo.policySwitch" :content="$t('DETAIL.EXCEEDEDPSTAR') +' '+ valueType + ' ' + $t('DETAIL.SYMBOL1')" OUTOFPOLICYTIPplacement="bottom" effect="light" v-if=" $objBaseInfo.hotelBookingRole ==1 && list.isOutOfPolicy===true && list.outOfPolicyReasons.length == 1 && list.outOfPolicyReasons[0]['key'] =='star'">
                        <div class="policy_outof_in policy_outof_color">{{ $t("MESSAGE.OUTOFPOLICY") }}</div>
                      </el-tooltip>
                      <el-tooltip :disabled="!$objBaseInfo.policySwitch" :content="($t('DETAIL.EXCEEDEDPRICE') +' '+ ($currencySign[list.currencyCode]?$currencySign[list.currencyCode]:list.currencyCode) + ' ' + valueType )" OUTOFPOLICYTIPplacement="bottom" effect="light" v-if=" $objBaseInfo.hotelBookingRole ==1 && list.isOutOfPolicy===true && list.outOfPolicyReasons.length == 1 && list.outOfPolicyReasons[0]['key'] =='amountTopLimit'">
                        <div class="policy_outof_in policy_outof_color">{{ $t("MESSAGE.OUTOFPOLICY") }}</div>
                      </el-tooltip>
                      <el-tooltip :disabled="!$objBaseInfo.policySwitch" :content="$t('RESULT.OUTOFPOLICYTIP3') " OUTOFPOLICYTIPplacement="bottom" effect="light" v-if=" $objBaseInfo.hotelBookingRole ==1 && list.isOutOfPolicy===true && list.outOfPolicyReasons.length == 1 && list.outOfPolicyReasons[0]['key'] =='NegotiationPrice'">
                        <div class="policy_outof_in policy_outof_color">{{ $t("MESSAGE.OUTOFPOLICY") }}</div>
                      </el-tooltip>
                      <el-tooltip :disabled="!$objBaseInfo.policySwitch" OUTOFPOLICYTIPplacement="bottom" effect="light" v-if=" $objBaseInfo.hotelBookingRole ==1 && list.isOutOfPolicy===true && list.outOfPolicyReasons.length == 2">
                        <template #content>
                          <div v-html="DialogContent"></div>
                        </template>
                        <div class="policy_outof_in policy_outof_color">{{ $t("MESSAGE.OUTOFPOLICY") }}</div>
                      </el-tooltip>
                      <el-tooltip :disabled="!$objBaseInfo.policySwitch" :content="$t('RESULT.OUTOFPOLICYTIPEMPTY')" OUTOFPOLICYTIPplacement="bottom" effect="light" v-if=" $objBaseInfo.hotelBookingRole ==1 && list.isOutOfPolicy===true && list.outOfPolicyReasons.length == 1 && list.outOfPolicyReasons[0]['key'] =='cwtTrip'">
                        <template #content>
                          <div v-html="$t('RESULT.OUTOFPOLICYTIPEMPTY')"></div>
                        </template>
                        <div class="policy_outof_in policy_outof_color">{{ $t("MESSAGE.OUTOFPOLICY") }}</div>
                      </el-tooltip>
                    </div>
                    <div class="policy_outof_in policy_in_color" v-if="$objBaseInfo.hotelBookingRole ==1 && list.isOutOfPolicy===false">
                      {{ $t("MESSAGE.INPOLICY") }}
                    </div>
                    <div class="policy_outof_in" v-if="list.isOutOfPolicy!==true && list.isOutOfPolicy!==false">&nbsp;</div>
                  </div>
                  <div class="price">
                        <el-tooltip v-if=" list.hasTax" class="item" effect="light" :content="$t('DETAIL.AVGNIGHTLYRATE')+list.taxCurrency+list.avgNightly" placement="bottom-start">
                          <span  class="el-icon-info"></span>
                      </el-tooltip>
                    {{list.averagePrice ? (($currencySign[list.currencyCode]?$currencySign[list.currencyCode]:list.currencyCode) + list.averagePrice) :'N/A' }}
                    <span v-if=" list.hasTax" style="font-size:12px">({{ $t("DETAIL.TAXIN") }})</span>
                  </div>
                  <div
                    v-if="changeCurrency === '0' && list.usDollar"
                    class="price"
                  >
                    <span style="font-size: 10px; font-weight: normal">{{
                      $t("RESULT.ESTIMATEDPRICE")
                    }}</span
                    ><span style="font-size: 10px; font-weight: normal"
                      >&nbsp;${{ list.usDollar }}</span
                    >
                  </div>
                  <div
                    v-if="changeCurrency === '1' && list.european"
                    class="price"
                  >
                    <span style="font-size: 10px; font-weight: normal">{{
                      $t("RESULT.ESTIMATEDPRICE")
                    }}</span>
                    <span style="font-size: 10px; font-weight: normal"
                      >&nbsp;€{{ list.european }}</span
                    >
                  </div>
                  <div
                    v-if="changeCurrency === '2' && list.ChineseCNY"
                    class="price"
                  >
                    <span style="font-size: 10px; font-weight: normal">{{
                      $t("RESULT.ESTIMATEDPRICE")
                    }}</span
                    ><span style="font-size: 10px; font-weight: normal"
                      >&nbsp;¥{{ list.ChineseCNY }}</span
                    >
                  </div>
                  <button class="select_btn" v-if="!$objBaseInfo.isOnlySearch" @click="NonCancellableMessage(item, list)">
                    <span v-if="list.source != 'CWTbur'">{{ $t("DETAIL.BTN2") }}</span>
                    <span v-else>{{ $t("DETAIL.BTNCWTBUR") }}</span>
                  </button>
                </el-col>
              </el-row>
            </div>
            <el-row class="content_size showmore_content" v-if="newRoomTypeList[index].ratePlans.length > 1">
              <el-col :span="24" class="center_style">
                <p class="grid-content showmore_font" @click="showMore(index, item)" v-if="item.showTitle">
                  <i aria-hidden="true" class="el-icon-arrow-down"></i>
                  {{ $i18n.locale === "en" ? item.showOnEn : item.showOnCn }}
                </p>
                <p class="grid-content showmore_font" @click="packUp(index, item)" v-if="item.packTitle">
                  <i aria-hidden="true" class="el-icon-arrow-up"></i>
                  {{ $i18n.locale === "en" ? item.packEn : item.packCn }}
                </p>

              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <div v-for="(list) in originData" :key="list.roomDescriptiveInfo.id">
          <el-dialog width="min(90vw, 76rem)" v-model="dialogImageCom" :show-close="false" class="dialog-image room-image-dialog" style="background: rgba(0, 0, 0, 0.7);" v-if="dilogID === list.roomDescriptiveInfo.id">
            <el-row>
              <el-col :span="17">
                <el-carousel class="carousel-image" ref="carousel" arrow="always" :autoplay="false">
                  <el-carousel-item v-for="(type,index) in list.roomDescriptiveInfo.photoList" :key="index">
                    <el-image
                      class="room-photo-image"
                      fit="fill" 
                      :src="type && type !== 'default' ? type : require('@/assets/img/room_img_error.png')" 
                      :onerror="defaultImgRoom"
                    ></el-image>
                  </el-carousel-item>
                </el-carousel>
              </el-col>
              <el-col :span="1"></el-col>
              <el-col :span="6" class="image-carousel-right">
                <ul class='text-right'>
                  <li>
                    <h3>{{ $t("DETAIL.PROPERTYINFO") }}</h3>
                  </li>
                  <li>
                    <svg-icon icon-class="ic_area" style="float :left"></svg-icon> <span>{{ (roomInfo.area =='N/A' || roomInfo.area =='暂无数据' )? roomInfo.area : roomInfo.area +'㎡' }}</span>
                  </li>
                  <li>
                    <svg-icon icon-class="ic_bed" style="float :left"></svg-icon><span>{{ $i18n.locale === "en" ? roomInfo.bedTypeEn : roomInfo.bedTypeCh }}</span>
                  </li>
                  <li>
                    <svg-icon icon-class="ic_domain" style="float :left"></svg-icon><span>{{ roomInfo.floor}}</span>
                  </li>
                  <li v-show="roomInfo.wifi == 0">
                    <svg-icon icon-class="wifi_2" style="float :left"></svg-icon><span>{{  $t("COMMONPARAM.WIFI.WIFI0")}}</span>
                  </li>
                  <li v-show="roomInfo.wifi == 1">
                    <svg-icon icon-class="wifi_2" style="float :left"></svg-icon><span>{{  $t("COMMONPARAM.WIFI.WIFI1")}}</span>
                  </li>
                  <li v-show="roomInfo.wifi == 2">
                    <svg-icon icon-class="wifi_2" style="float :left"></svg-icon><span>{{  $t("COMMONPARAM.WIFI.WIFI2")}}</span>
                  </li>
                  <li v-show="roomInfo.wifi == 3">
                    <svg-icon icon-class="wifi_2" style="float :left"></svg-icon><span>{{  $t("COMMONPARAM.WIFI.WIFI3")}}</span>
                  </li>
                  <li v-show="roomInfo.wifi == 4">
                    <svg-icon icon-class="wifi_2" style="float :left"></svg-icon><span>{{  $t("COMMONPARAM.WIFI.WIFI4")}}</span>
                  </li>
                </ul>
              </el-col>
            </el-row>
            <el-row style="margin-top: 1rem">
              <el-col :span="17" class="image-list-scroll">
                <el-image v-for="(type,index) in list.roomDescriptiveInfo.photoList" :key="index" @click="selectImg(index)" style="width: 100px; height: 80px; margin-right: 1rem" :src="type && type !== 'default' ? type : require('@/assets/img/room_img_error.png')" :onerror="defaultImgRoom">
                </el-image>
              </el-col>
            </el-row>
          </el-dialog>
        </div>

      </div>

      <!-- 图片显示 -->
      <div>
        <el-dialog v-model="dialogRefresh" width="32rem" center :show-close="false" class="d_confirm d_confirm_refresh">
          <div class="dialog-span-fixed">
            <div>
              <svg-icon icon-class="exclamation"></svg-icon>
            </div>
            <div style="text-align: center">
              <span class="dialog-span-content" v-html="$t('CONFIRMATION.REFRESHCONTENT')">
              </span>
            </div>
          </div>
          <template #footer>
            <span class="dialog-footer dialog-footer-right">
              <button class="dialog_btn_y btn_dialog" @click="refresh">
                {{ $t("CONFIRMATION.REFRESHBTN") }}
              </button>
            </span>
          </template>
        </el-dialog>
        <el-dialog v-model="dialogProceed" width="40rem" center :show-close="false" class="d_confirm">
          <span class="dialog-span-fixed">
            <svg-icon icon-class="exclamation"></svg-icon>
            <span class="dialog-span-content">
              <div> 
                {{ $t("DETAIL.PRICECHANGED") }}
                <br />
                {{ $t("DETAIL.ORGPRICE") }} {{ originAmount }}
                {{ $t("DETAIL.NEWPRICE") }} {{ newAmount }}
              </div>
            </span>
          </span>
          <template #footer>
            <span class="dialog-footer">
              <button class="dialog_btn_y btn_dialog" @click="toBookingPriceChange('change')">
                {{ $t("CONFIRMATION.PROCEED") }}
              </button>
              <button class="dialog_btn_n btn_dialog" @click="refresh">
                {{ $t("CONFIRMATION.REFRESHBTN") }}
              </button>
            </span>
          </template>
        </el-dialog>
        <el-dialog v-model="dialogOut" width="40rem" center :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" class="d_confirm">
          <span class="dialog-span-fixed">
            <svg-icon icon-class="exclamation"></svg-icon>
            <span class="dialog-span-content" v-html="outMsg">
            </span>
          </span>
          <template #footer>
          <span class="dialog-footer">
            <button class="dialog_btn_y btn_dialog" @click="toBookingPriceChange('out')">
              {{ $t("CONFIRMATION.PROCEED") }}
            </button>
            <button class="dialog_btn_n btn_dialog" @click="refresh">
              {{ $t("CONFIRMATION.CANCLEBTN") }}
            </button>
          </span>
          </template>
        </el-dialog>
        <el-dialog v-model="NonCancellabledialog" width="40rem" center :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" class="d_confirm">
          <span class="dialog-span-fixed">
            <svg-icon icon-class="exclamation"></svg-icon>
            <span class="dialog-span-content">
              {{$t("DETAIL.CannotBeCanceled")}}
            </span>
          </span>
          <template #footer>
          <span class="dialog-footer">
            <button class="dialog_btn_y btn_dialog" @click="toBooking(NonCancellableItem,NonCancellableList)">
              {{ $t("CONFIRMATION.PROCEED") }}
            </button>
            <button class="dialog_btn_n btn_dialog" @click="NonCancellabledialog=false">
              {{ $t("CONFIRMATION.CANCLEBTN") }}
            </button>
          </span>
          </template>
        </el-dialog>
      </div>
    </div>
    <!-- end :: Web -->
    <!-- begin :: mobile -->
    <div v-else class="detail_room_list">
      <van-dropdown-menu>
        <!-- 价格范围 -->
        <van-dropdown-item v-if="!$objBaseInfo.onlyShowBestPrice" v-model="priceRangeValue" :options="priceRangeOption" :title="priceRangeTitle" @closed="priceRangeClose(priceRangeValue)"/>
        <!-- 筛选 -->
        <van-dropdown-item :title="$t('RESULT.MOBILELOCATION')" ref="location" v-if="!$objBaseInfo.onlyShowBestPrice">
          <div style="margin: 1rem 31rem 0 3rem;">
            <van-cell :title="$t('DETAIL.BestPrice')" style="color: #646566;">
              <template #right-icon>
                <van-switch v-model="bestPriceChecked" size="20" @change="bestPriceCheckedChange"/>
              </template>
            </van-cell>
          </div>
          <div style="margin: 1rem;text-align: center;display: flex;flex-wrap: wrap;">
            <div v-for="item in filterList" :key="item.value">
              <van-tag type="primary" size="large" plain :class="{ 'click-dist-tag': filterGroup.includes(item.value),}" @click="h5FilterClick(item)">
                {{ item.label[$t('COMMONPARAM.RESPONSEDATA.SHOWTYPE')] }}
              </van-tag>
            </div>
          </div>
          <div style="padding: 0.5rem 1.6rem;">
            <van-button type="danger" class="top-vant-btn" block round @click="onTreeReset">
              {{ $t("MESSAGE.RESETBTN") }}
            </van-button>
            <van-button type="danger" class="top-vant-btn" block round @click="filterRoomTypeList">
              {{ $t("MESSAGE.CONFIRMBTN") }}
            </van-button>
          </div>
        </van-dropdown-item>
        <van-dropdown-item title-class="no-arrow" :title="$t('DETAIL.SearchNearbyHotels')" @open="toHotelList"/>
      </van-dropdown-menu>
      <ConfirmBoxs :centerDialogVisible="confirmFlag" :confirmMsg="confirmMsg" :icon="confirmIcon" @setConfirmFlag="setConfirmFlag"></ConfirmBoxs>
      <div class="no_List" style="color: #1061cc;" v-if="showTag"> {{ $t("DETAIL.NOMORETITLE") }}</div>
      <div class="room_list" v-for="(item, index) in newRoomTypeList" :key="index" style="padding:0 10px">
        <div class="roomBasic" v-if="item.ratePlans.length >0">
          <el-row>
            <el-col :span="6" class="room_panel">
              <div class="room_pic">
                <img style="width: 100%; height: 100%" :src="
                    item.roomDescriptiveInfo.photos[0]
                      ? item.roomDescriptiveInfo.photos[0]
                      : require('@/assets/img/room_img_error.png')
                  " :onerror="defaultImgRoom" alt="defaultImgRoom" @click="showViewImage(item)" />
              </div>
            </el-col>
            <el-col :span="16">
              <div class="middle">
                <el-row>
                  <el-col>
                    <div class="room_name">{{$i18n.locale == "en" ? (item.roomDescriptiveInfo.name.en ? item.roomDescriptiveInfo.name.en :'N/A') : (item.roomDescriptiveInfo.name['zh-CN'] ? item.roomDescriptiveInfo.name['zh-CN'] : '暂无数据')  }}
                    </div>
                    <!-- <div class="room_name room_name_Inter" v-if="$objBaseInfo.destinationType == 'I'" @click="showDescription(item.roomDescriptiveInfo.description)">
                      {{item.roomDescriptiveInfo.description}}
                    </div> -->
                  </el-col>
                </el-row>
                <div style="margin-top: 5%;" class="room_describe">
                  <template v-if="item.roomDescriptiveInfo.bedTypeCode">
                    <div class="room_describe_item">
                      <div class="bedCount">
                        {{ getBedCode(item.roomDescriptiveInfo.bedTypeCode)}}
                      </div>
                    </div>
                    <span>{{ separator }}</span>
                  </template>
                  <template v-if="item.roomDescriptiveInfo.hasWindow <= 6 || item.roomDescriptiveInfo.hasWindow == 99">
                    <div class="room_describe_item">
                      <div v-if="ShowWindow(item)">
                        <!-- <svg-icon style="float: left" icon-class="Non-window" className="detail_icon"></svg-icon> -->
                        <span>{{ $t("COMMONPARAM.WINDOW.WINDOW0") }}</span>
                      </div>

                      <div v-if="item.roomDescriptiveInfo.hasWindow == 1">
                        <!-- <svg-icon style="float: left" icon-class="window" className="detail_icon"></svg-icon> -->
                        <span>{{ $t("COMMONPARAM.WINDOW.WINDOW1") }}</span>
                      </div>
                      <div v-if="item.roomDescriptiveInfo.hasWindow == 2">
                        <!-- <svg-icon style="float: left" icon-class="window" className="detail_icon"></svg-icon> -->
                        <span>{{ $t("COMMONPARAM.WINDOW.WINDOW2") }}</span>
                      </div>
                      <div v-if="item.roomDescriptiveInfo.hasWindow == 3">
                        <!-- <svg-icon style="float: left" icon-class="window" className="detail_icon"></svg-icon> -->
                        <span>{{ $t("COMMONPARAM.WINDOW.WINDOW3") }}</span>
                      </div>
                      <div v-if="item.roomDescriptiveInfo.hasWindow == 4">
                        <!-- <svg-icon style="float: left" icon-class="window" className="detail_icon"></svg-icon> -->
                        <span>{{ $t("COMMONPARAM.WINDOW.WINDOW4") }}</span>
                      </div>
                      <div v-if="item.roomDescriptiveInfo.hasWindow == 5">
                        <!-- <svg-icon style="float: left" icon-class="window" className="detail_icon"></svg-icon> -->
                        <span>{{ $t("COMMONPARAM.WINDOW.WINDOW5") }}</span>
                      </div>
                      <div v-if="item.roomDescriptiveInfo.hasWindow == 6">
                        <!-- <svg-icon style="float: left" icon-class="window" className="detail_icon"></svg-icon> -->
                        <span>{{ $t("COMMONPARAM.WINDOW.WINDOW6") }}</span>
                      </div>
                    </div>
                    <span>{{ separator }}</span>
                  </template>
                  <template v-if="item.roomDescriptiveInfo.maximumOccupancy">
                    <div class="room_describe_item">
                      <div class="peopleCount">
                        <!-- <svg-icon v-for="item in item.roomDescriptiveInfo.bedCount" :key="item" icon-class="guest" class-name="detail_icon"></svg-icon> -->
                      {{ $t("DETAIL.GUEST", item.roomDescriptiveInfo.maximumOccupancy, { bedCount: item.roomDescriptiveInfo.maximumOccupancy }) }}
                      </div>
                    </div>
                    <span>{{ separator }}</span>
                  </template>
                  <template v-if="item.roomDescriptiveInfo.area">
                    <div class="room_describe_item">
                      <div class="peopleCount" :class="{ 'en-style': $i18n.locale == 'en' }">{{ item.roomDescriptiveInfo.area + "㎡" }}</div>
                    </div>
                  {{ separator }}
                  </template>
                  <template v-if="item.roomDescriptiveInfo.floor">
                    <div class="room_describe_item">
                      <div>
                        <svg-icon icon-class="ic_domain1" className="detail_icon"></svg-icon><span>{{ item.roomDescriptiveInfo.floor }}</span>
                      </div>
                    </div>
                    {{ separator }}
                  </template>
                  <div class="room_describe_item">
                    <svg-icon icon-class="wifi_3" className="detail_icon"></svg-icon>
                    <span>{{ getWifiText(item.roomDescriptiveInfo.wifi) }}</span>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="2">
              <div class="openBtn">
                <svg-icon icon-class="down-circle" @click="showAll(item)" v-if="!item.allData"></svg-icon>
                <svg-icon icon-class="up-circle-fill" @click="hideAll(item)" v-if="item.allData"></svg-icon>
              </div>
            </el-col>
          </el-row>
        </div>
        <div v-for="(list, index) in item.ratePlans" :key="index" style="margin-top: 1%;">
          <div class="roomDetail" v-if="item.allData">
            <van-row>
              <van-col span="24">
                <div style="font-size: 14px;font-family: 'Source-Sans-Pro-Semibold';padding-top: 10px;" v-html="RoomDetailText1(list)"></div>
              </van-col>
            </van-row>
            <!-- 第2行：居左 -->
            <van-row style="display: flex;flex-wrap: wrap;align-items: end;">
              <van-col span="24" class="tagClass">
                <van-tag type="primary" size="medium" plain v-if="list.paymentType == 1">
                  {{ $t("DETAIL.PAYMENTTYPE1") }}
                </van-tag>
                <van-tag type="primary" size="medium" plain v-if="list.paymentType == 2">
                  {{ $t("DETAIL.PAYMENTTYPE2") }}
                </van-tag>
                <van-tag type="primary" size="medium" plain v-if="list.paymentType == 3">
                  {{ $t("DETAIL.PAYMENTTYPE3") }} 
                </van-tag>
                <van-tag type="primary" size="medium" plain v-if="list.isGuaranteeRequired">
                  <el-tooltip 
                    v-if="GetGuaranteeTooltip(list) != ''" 
                    :content="GetGuaranteeTooltip(list)" 
                    placement="top-end" 
                    effect="light"
                  >
                    <span class="guarantee-content" style="font-weight:600;">
                      {{ GetGuaranteeText(list) }}
                      <svg-icon icon-class="exclamationNew" class="guarantee-icon"></svg-icon>
                    </span>
                  </el-tooltip>
                  <span v-else class="guarantee-content">
                    {{ GetGuaranteeText(list) }}
                  </span>
                </van-tag>
                <van-tag type="primary" size="medium" plain v-if="list.bookingType == 'normal'">
                  {{ $t("DETAIL.INSTANT") }}
                </van-tag>
                <van-tag type="primary" size="medium" plain v-if="list.bookingType == 'bur'">
                  {{ $t("DETAIL.DELAY") }}
                </van-tag>
              </van-col>
            </van-row>
            <!-- 第3行：居右 -->
            <van-row type="flex" justify="end">
              <van-col span="24">
                <div class="price" style="font-size: 2.8rem;margin:0;font-family: 'Source-Sans-Bold';">
                  <el-tooltip v-if=" list.hasTax" class="item" effect="light" :content="$t('DETAIL.AVGNIGHTLYRATE')+list.taxCurrency+list.avgNightly" placement="bottom-start">
                      <span style="font-size: 17px;" class="el-icon-info"></span>
                  </el-tooltip>
                  <span style="font-size: 12px;font-family: 'Source-Sans-Pro-Semibold';">{{$currencySign[list.currencyCode]?$currencySign[list.currencyCode]:list.currencyCode}}</span>
                {{ list.averagePrice ? list.averagePrice : "N/A" }}
                  <span v-if=" list.hasTax" style="font-size:12px">({{ $t("DETAIL.TAXIN") }})</span>
                </div>
              </van-col>
            </van-row>
            <!-- 第4行：居右 -->
            <van-row type="flex" justify="end" style="font-family: 'Source-Sans-Bold';">
              <div v-if="changeCurrency === '0' && list.usDollar" class="price exchange-rate">{{list.averagePrice ? $t('RESULT.ESTIMATEDPRICE')+' '+'$' + list.usDollar :'N/A' }}</div>
              <div v-if="changeCurrency === '1' && list.european" class="price exchange-rate">{{list.averagePrice ? $t('RESULT.ESTIMATEDPRICE')+' '+'€' + list.european :'N/A' }}</div>
              <div v-if="changeCurrency === '2' && list.ChineseCNY" class="price exchange-rate">{{list.averagePrice ? $t('RESULT.ESTIMATEDPRICE')+' '+'¥' + list.ChineseCNY :'N/A' }}</div>
            </van-row>
            <!-- 第5行：居右 -->
            <van-row type="flex" justify="end">
              <van-col class="otherTagClass">
                <van-tag type="primary" size="medium" plain v-if="list.isIntegral==true">
                  {{ $t("DETAIL.LoyaltyPoints") }}
                </van-tag>    
                 <van-tag type="primary" size="medium" plain v-if="list.isIntegral==false">
                  {{ $t("DETAIL.NoLoyaltyPoints") }}
                </van-tag>   
                <van-tag type="primary" size="medium" plain v-if="list.channelDescription!=null">
                  {{ list.channelDescription[$t('COMMONPARAM.RESPONSEDATA.SHOWTYPE')] }}
                </van-tag>
                <van-tag type="primary" size="medium" plain v-if="list.priceType == 0 && !list.priceOwner == '' && list.priceOwner == 'cwt'">
                  {{$t("DETAIL.CWTPRICE")}}
                </van-tag>
                <van-tag type="primary" size="medium" plain v-if="list.priceType == 0 && !list.priceOwner == '' && list.priceOwner != 'cwt' && ChainwidePrice(list) != ''">
                  {{ $t("DETAIL.CLIENTPRICE") + ChainwidePrice(list)}}
                </van-tag>
                <van-tag type="primary" style="font-weight: 600;" size="medium" plain v-if="list.priceType == 0 && !list.priceOwner == '' && list.priceOwner != 'cwt' && ChainwidePrice(list) == ''">
                  {{ $t("DETAIL.CLIENTPRICE")}}
                </van-tag>
              </van-col>
            </van-row>
            <!-- 第6行：居右 -->
            <van-row type="flex" justify="space-between">
              <van-col>
                <div class="right_part">
                  <div v-if="$objBaseInfo.showTravelTitle && $objBaseInfo.displayTravelRules">
                    <div v-if="$objBaseInfo.hotelBookingRole ==1 &&list.isOutOfPolicy === true && $objBaseInfo.policySwitch && $objBaseInfo.personalizationPolicySwitch && $objBaseInfo.personalizationPolicyInfo && $objBaseInfo.personalizationPolicyInfo.descCn">
                      <el-tooltip :content="$i18n.locale === 'en' && $objBaseInfo.personalizationPolicyInfo && $objBaseInfo.personalizationPolicyInfo.descEn ? $objBaseInfo.personalizationPolicyInfo.descEn : ($objBaseInfo.personalizationPolicyInfo && $objBaseInfo.personalizationPolicyInfo.descCn ? $objBaseInfo.personalizationPolicyInfo.descCn : '')" placement="bottom" effect="light">
                        <div v-if="$objBaseInfo.hotelBookingRole ==1 && list.isOutOfPolicy === true && $objBaseInfo.policySwitch && $objBaseInfo.personalizationPolicySwitch && $objBaseInfo.personalizationPolicyInfo && $objBaseInfo.personalizationPolicyInfo.descCn">
                          <el-tooltip OUTOFPOLICYTIPplacement="bottom" effect="light">
                            <template #content>
                              <div style="text-align: center;overflow: hidden;" v-text="($i18n.locale == 'en' ?$objBaseInfo.personalizationPolicyInfo.descEn :$objBaseInfo.personalizationPolicyInfo.descCn)"></div>
                            </template>
                            <div class="policy_outof_in policy_outof_color">
                              {{ $t("MESSAGE.OUTOFPOLICY") }}
                            </div>
                          </el-tooltip>
                        </div>
                      </el-tooltip>
                    </div>
                    <div v-else>
                      <el-tooltip :disabled="!$objBaseInfo.policySwitch" :content="$t('DETAIL.EXCEEDEDPSTAR') + ' ' + valueType + ' ' + $t('DETAIL.SYMBOL1')" OUTOFPOLICYTIPplacement="bottom" effect="light" v-if="
                          $objBaseInfo.hotelBookingRole == 1 &&
                          list.isOutOfPolicy === true &&
                          list.outOfPolicyReasons.length == 1 &&
                          list.outOfPolicyReasons[0]['key'] == 'star'
                        ">
                        <div class="policy_outof_in policy_outof_color">
                          {{ $t("MESSAGE.OUTOFPOLICY") }}
                        </div>
                      </el-tooltip>
                      <el-tooltip :disabled="!$objBaseInfo.policySwitch" :content="
                        $t('DETAIL.EXCEEDEDPRICE') +' ' +($currencySign[list.currencyCode]?$currencySign[list.currencyCode]:list.currencyCode) +' ' +valueType" 
                          OUTOFPOLICYTIPplacement="bottom" effect="light" v-if="
                          $objBaseInfo.hotelBookingRole == 1 &&
                          list.isOutOfPolicy === true &&
                          list.outOfPolicyReasons.length == 1 &&
                          list.outOfPolicyReasons[0]['key'] == 'amountTopLimit'
                        ">
                        <div class="policy_outof_in policy_outof_color">
                          {{ $t("MESSAGE.OUTOFPOLICY") }}
                        </div>
                      </el-tooltip>
                      <el-tooltip :disabled="!$objBaseInfo.policySwitch" :content="$t('RESULT.OUTOFPOLICYTIP3') " OUTOFPOLICYTIPplacement="bottom" effect="light" v-if="
                          $objBaseInfo.hotelBookingRole == 1 &&
                          list.isOutOfPolicy === true &&
                          list.outOfPolicyReasons.length == 1 &&
                          list.outOfPolicyReasons[0]['key'] == 'NegotiationPrice'
                        ">
                        <div class="policy_outof_in policy_outof_color">
                          {{ $t("MESSAGE.OUTOFPOLICY") }}
                        </div>
                      </el-tooltip>
                      <el-tooltip :disabled="!$objBaseInfo.policySwitch" OUTOFPOLICYTIPplacement="bottom" effect="light" v-if="
                          $objBaseInfo.hotelBookingRole == 1 &&
                          list.isOutOfPolicy === true &&
                          list.outOfPolicyReasons.length == 2
                        ">
                        <template #content>
                          <div v-html="DialogContent"></div>
                        </template>
                        <div class="policy_outof_in policy_outof_color">
                          {{ $t("MESSAGE.OUTOFPOLICY") }}
                        </div>
                      </el-tooltip>
                       <el-tooltip :disabled="!$objBaseInfo.policySwitch" :content="
                        $t('RESULT.OUTOFPOLICYTIPEMPTY')" 
                          OUTOFPOLICYTIPplacement="bottom" effect="light" v-if="
                          $objBaseInfo.hotelBookingRole == 1 &&
                          list.isOutOfPolicy === true &&
                          list.outOfPolicyReasons.length == 1 &&
                          list.outOfPolicyReasons[0]['key'] == 'cwtTrip'
                        ">
                        <div class="policy_outof_in policy_outof_color">
                          {{ $t("MESSAGE.OUTOFPOLICY") }}
                        </div>
                      </el-tooltip>
                      <div>
                        <div class="policy_outof_in policy_in_color" v-if="
                            $objBaseInfo.hotelBookingRole == 1 &&
                            list.isOutOfPolicy === false
                          ">
                          {{ $t("MESSAGE.INPOLICY") }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </van-col>
              <van-col>
                <button class="select_btn" v-if="!$objBaseInfo.isOnlySearch" @click="NonCancellableMessage(item, list)">
                  <span v-if="list.source != 'CWTbur'">{{ $t("DETAIL.BTN2") }}</span>
                  <span v-else>{{ $t("DETAIL.BTNCWTBUR") }}</span>
                </button>
              </van-col>
            </van-row>
          </div>
        </div>
      </div>

      <!-- 图片显示 -->
      <div>
        <el-dialog v-model="dialogRefresh" width="90%" center :show-close="false" class="d_confirm d_confirm_refresh">
          <div class="dialog-span-fixed">
            <div>
              <svg-icon icon-class="exclamation"></svg-icon>
            </div>
            <div style="text-align: center">
              <span class="dialog-span-content" v-html="$t('CONFIRMATION.REFRESHCONTENT')">
              </span>
            </div>
          </div>
          <template #footer>
            <span class="dialog-footer dialog-footer-right">
              <button class="dialog_btn_y btn_dialog" @click="refresh">
                {{ $t("CONFIRMATION.REFRESHBTN") }}
              </button>
            </span>
          </template>
        </el-dialog>
        <el-dialog v-model="dialogProceed" width="90%" center :show-close="false" class="d_confirm">
          <span class="dialog-span-fixed">
            <svg-icon icon-class="exclamation"></svg-icon>
            <span class="dialog-span-content">
              <div>
                {{ $t("DETAIL.PRICECHANGED") }}
                <br />
                {{ $t("DETAIL.ORGPRICE") }} {{ this.originAmount }}
                {{ $t("DETAIL.NEWPRICE") }} {{ this.newAmount }}
              </div>
            </span>
          </span>
          <template #footer>
            <span class="dialog-footer">
              <button class="dialog_btn_y btn_dialog" @click="toBookingPriceChange('change')">
                {{ $t("CONFIRMATION.PROCEED") }}
              </button>
              <button class="dialog_btn_n btn_dialog" @click="refresh">
                {{ $t("CONFIRMATION.REFRESHBTN") }}
              </button>
            </span>
          </template>
        </el-dialog>
        <el-dialog v-model="dialogOut" width="90%" center :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" class="d_confirm">
          <span class="dialog-span-fixed">
            <svg-icon icon-class="exclamation"></svg-icon>
            <span class="dialog-span-content" v-html="outMsg"></span>
          </span>
          <template #footer>
          <span class="dialog-footer">
            <button class="dialog_btn_y btn_dialog" @click="toBookingPriceChange('out')">
              {{ $t("CONFIRMATION.PROCEED") }}
            </button>
            <button class="dialog_btn_n btn_dialog" @click="refresh">
              {{ $t("CONFIRMATION.CANCLEBTN") }}
            </button>
          </span>
          </template>
        </el-dialog>
        <el-dialog v-model="NonCancellabledialog" width="90%" center :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" class="d_confirm">
          <span class="dialog-span-fixed">
            <svg-icon icon-class="exclamation"></svg-icon>
            <span class="dialog-span-content">
                {{$t("DETAIL.CannotBeCanceled")}}
            </span>
          </span>
          <template #footer>
          <span class="dialog-footer">
            <button class="dialog_btn_y btn_dialog" @click="toBooking(NonCancellableItem,NonCancellableList)">
              {{ $t("CONFIRMATION.PROCEED") }}
            </button>
            <button class="dialog_btn_n btn_dialog" @click="NonCancellabledialog=false">
              {{ $t("CONFIRMATION.CANCLEBTN") }}
            </button>
          </span>
          </template>
        </el-dialog>
      </div>
    </div>
    <el-dialog v-model="showCustomizePriceRange" width="35rem" center :title="$t('RESULT.PRICERANGE')" class="customWidth" :close-on-click-modal="false">
      <div class="form">
        <el-row :gutter="20" justify="center" align="middle">
          <el-col :xs="8" :lg="8">
            <el-input size="default" v-model="minNumber" @input="clearNoNumPriceRangeFrom()"></el-input>
          </el-col>
          <el-col :xs="8" :lg="2" style="text-align: center;">
            <span style="font-size: 16px;">-</span>
          </el-col>
          <el-col :xs="8" :lg="8">
            <el-input size="default" v-model="maxNumber" @input="clearNoNumPriceRangeTo()"></el-input>
          </el-col>
        </el-row>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <button class="s_btn btn_dialog" @click="searchPriceRange()">{{ $t("MESSAGE.CONFIRMBUTTONTEXT") }}</button>
          <button class="dialog_btn_n btn_dialog" @click="showCustomizePriceRange = false">{{ $t("MESSAGE.CONFIRMCANCELTEXT") }}</button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import SvgIcon from "../../components/SvgIcon.vue";
// import DetailDialogImage from "../../components/DetailDialogImage.vue";
import { availabilityProperty } from "@/api/shoppingData.js";
import { formatDateTime, dateChange, validateTrip ,isCityGAT} from "@/utils/utils.js";
import { bookingsPropertyRate } from "@/api/bookingData.js";
import ConfirmBoxs from "@/components/confirmBoxs.vue";
import Loading from "@/components/Loading.vue";
import { Toast, showImagePreview } from "vant";
import { getDictionaryItem } from "@/utils/getDictionaryData.js";

export default {
  components: {
    [Toast.name]: Toast,
    SvgIcon,
    // DetailDialogImage,
    ConfirmBoxs,
    Loading,
  },
  name: "RoomList",
  props: {
    toBookingParams: Object,
    propsValue: Array,
    changeCurrency:String,
  },
  data() {
    return {
      dilogID: "",
      showTag: false,
      isJugeOut: false, //是否需要判断超标
      dialogOut: false,
      NonCancellabledialog: false,
      NonCancellableItem: null,
      NonCancellableList: null,
      NonCancellableRemark:"",
      outMsg: "",
      outOfPolicyWarning1: '',
      outOfPolicyWarning2: '',
      valueType: '',
      amountType: '',
      DialogContent: '',
      newPriceCalendar: [],
      errorData: '',
      errorMessage: '',
      newAmount: '',
      originAmount: '',
      confirmFlag: false,
      confirmIcon: "",
      confirmMsg: "",
      defaultImg: 'this.src="' + require("@/assets/img/hotel_img_error.png") + '";this.onerror=null;',
      defaultImgRoom: 'this.src="' + require("@/assets/img/room_img_error.png") + '";this.onerror=null;',
      photoList: [],
      loading: false,
      postdate1: '',
      postdate2: '',
      relaodArr: [],
      reasons: '',
      paymentType: '',
      roomInfo: {

      },
      roomTypeList: [],
      ratePlans: [],
      roomDescriptiveInfo: {},
      roomTypeId: "",
      originData: [],
      dialogImageCom: false,
      dialogRefresh: false,
      dialogProceed: false,
      bookingCreateParam: {}, //Booking 页面
      pathSource: this.$objBaseInfo.sourceType ? this.$objBaseInfo.sourceType : "",
      priceTripRuleType:"",
      isPrepay: false,
      isPublicPay: false,
      filterList:[
        { value: 1, label: { "zh-CN": "含早", en: "Breakfast included" },},
        { value: 2, label: { "zh-CN": "公司协议价", en: "Company Negotiated price" },},
        { value: 3, label: { "zh-CN": "即时预订", en: "Instant confirmation" },},
        { value: 4, label: { "zh-CN": "可免费取消", en: "Cancel with time limit" },},
        { value: 5, label: { "zh-CN": "需要担保", en: "Guarantee needed" },},
        { value: 6, label: { "zh-CN": "无需担保", en: "No Guarantee" },},
        { value: 7, label: { "zh-CN": "大床", en: "Double Bed" },},
        { value: 8, label: { "zh-CN": "双床", en: "Twin Bed" },},
        { value: 16, label: { "zh-CN": "可积分", en: "Loyalty Points" },},],
      filterGroup: [],
      newRoomTypeList:[],
      priceRangeOptions:[
        {value: 1,label: { "zh-CN": "不限", en: "unlimited" },},
        {value: 2,label: { "zh-CN": "0-300", en: "0-300" },},
        {value: 3,label: { "zh-CN": "300-500", en: "300-500" },},
        {value: 4,label: { "zh-CN": "500-1000", en: "500-1000" },},
        {value: 5,label: { "zh-CN": "1000以上", en: "From 1000" },},
        {value: 6,label: { "zh-CN": "自定义", en: "customize" },},
      ],
      priceAreaValue:"",
      minNumber: "",
      maxNumber: "",
      showCustomizePriceRange: false,
      priceRangeOption:[],
      priceRangeTitle: this.$t("RESULT.PRICERANGE"),
      priceRangeValue: 0,
      bestPriceChecked:false,
      showFilter:false,
    };
  },
  computed: {
    init: function () {
      this.originData = (JSON.parse(JSON.stringify(this.newRoomTypeList))).map(item => {
        let newItem = { ...item }
        if (item.ratePlans && item.ratePlans.length > 0) {
          newItem.ratePlans = [item.ratePlans[0]];
        }
        return newItem;
      })
    },
    GetGuaranteeText() {
      return function(item) {
        let content= this.$t('DETAIL.GUARANTEE');
        if(item.source.indexOf("sabre")>=0 && item.guaranteeRules[0].type=="deposit"){
          content=this.$t('DETAIL.DEPOSIT');
        }
         if(item.source.indexOf("booking")>=0 && item.paymentType==1 && item.cancellationPolicy==0){
          content=this.$t('DETAIL.PREPAYMENT');
        }
        return content;
      }
    },
    ShowWindow(){
      return function(item) {
        var content= false;
        const objBaseInfo = this.$objBaseInfo || {};
        const roomDescriptiveInfo = item && item.roomDescriptiveInfo ? item.roomDescriptiveInfo : {};
        if(roomDescriptiveInfo.hasWindow == 99){
          if (objBaseInfo.destinationType == "D" && !objBaseInfo.isGATCity) {
            content= true;
          }
        }else if(roomDescriptiveInfo.hasWindow == 0){
          content= true;
        }
        return content;
      }
    },
    // 价格范围
    getPriceRangeSelect() {
      return [
        { text: this.$t("RESULT.PRICERANGE"), value:  0 },
        { text: this.$t("RESULT.PRICERANGE1"), value: 1 },
        { text: this.$t("RESULT.PRICERANGE2"), value: 2 },
        { text: this.$t("RESULT.PRICERANGE3"), value: 3 },
        { text: this.$t("RESULT.PRICERANGE4"), value: 4 },
        { text: this.$t("RESULT.PRICERANGE5"), value: 5 },
        { text: this.$t("RESULT.PRICERANGE6"), value: 6 },
      ];
    },
    separator() {
      return "| ";
    },
  },
  updated() {
    this.warningContent();
    this.priceRangeOption =  this.getPriceRangeSelect;
  },
  mounted() {
    if(this.$objBaseInfo.onlyShowBestPrice){
      this.filterGroup.push(15);
    }
    switch (this.$route.query.paymentType) {
      case "0":
        this.filterGroup.push(10);
        break;
      case "1":
      this.filterGroup.push(9);
        break;
      case "2":
      this.filterGroup.push(11);
        break;
    }
    this.checkpaymentType();
  },
  watch: {
    getDate: function (newVal, oldVal) {
      this.getDate = newVal
      if (this.getDate) {
        this.value1 = this.getDate;
      } else {
        this.value1 = "";
      }
      this.getNight();
    },
    // 监听修改时间
    propsValue: {
      immediate: true,
      handler(newObj) {
        if (newObj && newObj.length == 2) {
          this.relaodArr = newObj;
          //住店
          this.postdate1 = formatDateTime(this.relaodArr[0], "YYYY-MM-DD");
          // 离店
          this.postdate2 = formatDateTime(this.relaodArr[1], "YYYY-MM-DD");
          //行程单验证
          let msg = validateTrip(this, this.toBookingParams.hotelInfo.city, this.postdate1, this.postdate2);
          if (msg != "") {
            this.confirmIcon = "exclamation";
            this.confirmMsg = msg;
            this.confirmFlag = true;
            this.roomTypeList = [];
            this.$emit("setListDate", []);
            this.$emit("setLoading", false);
            // return false;
          } else {
            //记录搜索条件
            let query = this.$store.state.pathQuery;
            if (query.searchParam) {
              let searchParam = JSON.parse(query.searchParam);
              searchParam.checkInAt = this.postdate1;
              searchParam.checkOutAt = this.postdate2;
              query.searchParam = JSON.stringify(searchParam);
              this.$store.commit("changePathQuery", query);
            }

            this.getRoomType();
          }
        }
      }
    },
    init: function () { },
    //监控入住人数量更新房型信息
    "toBookingParams.noGuests"(newVal, oldVal) {
      if (oldVal && newVal != oldVal) {
        this.getRoomType();
      }
    },
    "toBookingParams.noRooms"(newVal, oldVal) {
      if (oldVal && newVal != oldVal) {
        this.getRoomType();
     }
    },
    "toBookingParams.hotelInfo.groupId"(newVal, oldVal) {
      if (oldVal=='' && newVal != oldVal) {
        this.getRoomType();
     }
    },
    //价格范围变化
    priceRangeValue(newVal) {
      this.priceRangeTitle = this.getPriceRangeSelect[newVal].text
      this.handlePriceRangeChange(newVal);
    },
  },
  methods: {
    getBedCode(item) {
      return getDictionaryItem(item,'bedtype')[this.$t("DETAIL.RESPONSEDATA.bedtype")] || 'N/A';
    },
    showAll(item) {
      item.allData = true;
      setTimeout(() => {
        this.$emit("reChangeHeight");
      }, 1200);
    },
    hideAll(item) {
      item.allData = false;
      setTimeout(() => {
        this.$emit("reChangeHeight");
      }, 1200);
    },
    warningContent() {
      // if (this.$i18n.locale == "en") {
      //   this.DialogContent = this.$t('DETAIL.EXCEEDEDPRICE') + ' ' + this.$objBaseInfo.defaultCurrencySign + ' ' + this.amountType + '<br>' + this.$t('RESULT.OUTOFPOLICYTIP3') //+ ' ' + this.valueType + ' ' + this.$t('DETAIL.SYMBOL1')
      // }
      // else {
      //   this.DialogContent = this.$t('DETAIL.EXCEEDEDPRICE') + ' ' + this.$objBaseInfo.defaultCurrencySign + ' ' + this.amountType + '<br>' + this.$t('RESULT.OUTOFPOLICYTIP3') //+ ' ' + this.valueType + ' ' + this.$t('DETAIL.SYMBOL1')
      // }
      this.DialogContent = this.$t('DETAIL.EXCEEDEDPRICE') + ' ' + this.$objBaseInfo.defaultCurrencySign + ' ' + this.amountType + '<br>' + this.$t('RESULT.OUTOFPOLICYTIP3') //+ ' ' + this.valueType + ' ' + this.$t('DETAIL.SYMBOL1')
    },
    setConfirmFlag() {
      this.confirmFlag = false;
    },
    selectImg(item) {
      this.$refs.carousel.map(list => {
        list.setActiveItem(parseInt(item));
      })
    },
    getRoomPreviewImages(photoList) {
      return (photoList || []).map((photo) =>
        photo && photo !== "default" ? photo : require("@/assets/img/room_img_error.png")
      );
    },
    async getRoomType() {
      this.$parent.allLoading = true;
      this.$emit("setLoading", true);
      let params = {
        posCode: this.$objBaseInfo.poscode,
        //  hotelCode:"19110",
        hotelCode: this.toBookingParams.hotelcode.toString(),
        checkInDate: formatDateTime(this.postdate1, "YYYY-MM-DD"),
        checkOutDate: formatDateTime(this.postdate2, "YYYY-MM-DD"),
        noGuests: this.toBookingParams.noGuests,
        noRooms: this.toBookingParams.noRooms,
        bookingContactId: this.$objBaseInfo.loginID,
        source: this.pathSource, //请求来源OBT/CRM,供延时功能使用
        pageRequest: {
          page: 1,
          per_page: 10,
        },
        language: ["en-US", "zh-CN"],
        countryCode: this.toBookingParams.hotelInfo.countryCode,//this.$objBaseInfo.countryCode, //国家ID
        cwtCityCode: this.toBookingParams.hotelInfo.city,//this.$objBaseInfo.countryCode, //城市id
        //group:this.toBookingParams.hotelInfo.group,
        groupCode:this.toBookingParams.groupId,
      };
      if(Object.prototype.hasOwnProperty.call(this.$objBaseInfo,"openResource"))
      {
        if(this.$objBaseInfo.openResource!=undefined && this.$objBaseInfo.openResource!="" && this.$objBaseInfo.openResource!=null)
        {
          params.openResource=JSON.parse(this.$objBaseInfo.openResource);
        }
      }
      let that = this;
      if (that.$dictionaryData.Property) {
        //设置loading
        that.$emit("setLoading", false);
        that.processingData(that.$dictionaryData.Property);
        delete that.$dictionaryData.Property;
      } else {
        await availabilityProperty(params).then((res) => {
          //设置loading
          that.$emit("setLoading", false);
          if (res.code == 200) {
            if (res.data.error.code != 0) {
              that.roomTypeList = [];
              that.originData = [];
              that.newRoomTypeList = [];
              that.confirmFlag = true;
              that.confirmMsg = that.$t("ERRORMESSAGE." + res.data.error.code) === "ERRORMESSAGE." + res.data.error.code ? that.$t("ERRORMESSAGE.NOTFOUND") : that.$t("ERRORMESSAGE." + res.data.error.code);
              console.log("获取房型下拉框数据 请求失败, code:" + res.data.error.code, res.data.error.message);
            } else {
              const traceId = res.data && res.data.traceId
              if (traceId) {
                this.$emit('updateTraceId', traceId)
              }
              that.processingData(res);
            }
          }
          else {
            // that.$emit("setLoading", false);
            that.confirmMsg = that.$t("ERRORMESSAGE." + res.code) === "ERRORMESSAGE." + res.code ? that.$t("ERRORMESSAGE.NOTFOUND") : that.$t("ERRORMESSAGE." + res.code);
            console.log("获取房型下拉框数据 请求失败, code:" + res.code, res.message);
          }
          that.warningContent()
        })
          .catch(function (error) {
            that.$emit("setLoading", false);
            that.confirmFlag = true;
            that.confirmMsg = that.$t("ERRORMESSAGE." + error.mesCode);

            console.log("获取房型下拉框数据 请求失败", error.objError);
          });
      }
    },
    processingData(res) {
      this.roomTypeList = res.data.roomTypeList.map((item) => {
        if (this.$objBaseInfo.channelId === "WEB") {
          item.showTitle = true;
          item.packTitle = false;
          item.showOnCn = "显示更多";
          item.showOnEn = "Show More";
          item.packCn = "收起";
          item.packEn = "Show Less";
        } else {
          item.allData = false;
        }
        var newRatePlans = [];
        for(var i =0; i < item.ratePlans.length;i++){
            var ratePlan = [];
            newRatePlans.push(item.ratePlans[i]);
            if(item.ratePlans[i].paymentType == 3 && !this.isPublicPay)
            {
              newRatePlans.pop();//如果没有开通公付资源，移除当条价格信息
            }
            // if(item.ratePlans[i].paymentType == 3 && this.isPrepay){
            //   ratePlan = JSON.parse(JSON.stringify(item.ratePlans[i]));
            //   ratePlan.paymentType = 2;
            //   newRatePlans.push(ratePlan);
            // }
        };
        item.ratePlans = [...newRatePlans];
        item.ratePlans.map(list => {
          list.outOfPolicyReasons.map((form) => {
            
            if (form.key == 'amountTopLimit') {
              this.valueType = form.value
              this.amountType = form.value
            }
            return form
          })
          list.prices.map((per) => {
            list.price = per.publishedFare;
              // list.currencyType = per.taxAmount.currencyCode
            // if ( list.currencyType === "USD"){
            //     list.currencyBT = "$"
            //   }
            // else if ( list.currencyType === "EUR") {
            //       list.currencyBT = "€"
            //   }
          })
          if (this.$objBaseInfo.destinationType == "I" || this.$objBaseInfo.isGATCity) {
            
            if (JSON.stringify(list.taxes) !== "{}" || JSON.stringify(list.fees) !== "{}") {
              var priceSum = 0
              list.prices.forEach(element => {
                priceSum += element.beforeTaxAmount;
              });
              list.beforeTaxAmountTotal = priceSum;
              list.avgNightly = (priceSum /list.prices.length).toFixed(2);
              list.hasTax = true;
            }
            if (JSON.stringify(list.taxes) !== "{}") {
               list.taxAmount = list.taxes.amount;
               list.taxCurrency = list.taxes.currencyCode ? this.$currencySign[list.taxes.currencyCode] : "";
           }
           if (JSON.stringify(list.fees) !== "{}") {
               list.others = list.fees.amount;
               list.taxCurrency = list.fees.currencyCode ? this.$currencySign[list.fees.currencyCode] : ""
           }
          }
          list.convertedPrice.map(col=>{
            if (col.currencyCode === "USD"){
              list.usDollar = col.averagePrice;
            }
            else if (col.currencyCode === "EUR") {
              list.european = col.averagePrice
            }
             else if (col.currencyCode === "CNY") {
              list.ChineseCNY = col.averagePrice
            }
            return col;
          })
          return list
        })
        if (item.roomDescriptiveInfo.photos && item.roomDescriptiveInfo.photos.length > 0) {
          item.roomDescriptiveInfo.photoList = item.roomDescriptiveInfo.photos
        }
        else {
          item.roomDescriptiveInfo.photoList = ['default']
        }
        return item;
      });
      // 防止刷新后全局变量没有
      if (!this.$objBaseInfo.defaultCurrencyCode) {
        if (this.roomTypeList[0].ratePlans.length > 0) {
          this.$objBaseInfo.defaultCurrencyCode =
            this.roomTypeList[0].ratePlans[0].currencyCode;
          this.$objBaseInfo.defaultCurrencySign =
            this.$currencySign[this.$objBaseInfo.defaultCurrencyCode];
        }
      }
      this.filterRoomTypeList();
      //设置loading
      // this.$emit("setLoading", false);
      setTimeout(() => {
        this.$emit('reChangeHeight')
      }, 1200);
    },
    showMore(index, item) {
      item.showTitle = !item.showTitle;
      item.packTitle = !item.packTitle;
      for (let i = 0; i < this.newRoomTypeList.length; i++) {
        if (this.newRoomTypeList[i].ratePlans.length > 1) {
          this.originData[index].ratePlans = this.newRoomTypeList[index].ratePlans;
        }
      }
      setTimeout(() => {
        this.$emit('reChangeHeight')
      }, 1200);
    },
    packUp(index, item) {
      item.showTitle = !item.showTitle;
      item.packTitle = !item.packTitle;
      this.originData[index].ratePlans = [this.newRoomTypeList[index].ratePlans[0]];
      setTimeout(() => {
        this.$emit('reChangeHeight')
      }, 1200);
    },

    // 显示图片轮播弹框
    showViewImage(item) {
      if (this.$objBaseInfo.channelId !== "WEB") {
        showImagePreview({
          images: this.getRoomPreviewImages(item.roomDescriptiveInfo.photoList),
          startPosition: 0,
          closeable: true,
          loop: false,
        });
        return;
      }
      this.dilogID = item.roomDescriptiveInfo.id
      this.dialogImageCom = true;
      if (item.roomDescriptiveInfo.wifi) {
        this.roomInfo.wifi = item.roomDescriptiveInfo.wifi
      }
      else {
        this.roomInfo.wifi = this.$t("DETAIL.NA")
      }
      if (item.roomDescriptiveInfo.area) {
        this.roomInfo.area = item.roomDescriptiveInfo.area
      }
      else if (item.roomDescriptiveInfo.area === " "){

          this.roomInfo.area = this.$t("DETAIL.NA")
      }
      else {
        this.roomInfo.area = this.$t("DETAIL.NA")
      }
      if (item.roomDescriptiveInfo.floor) {
        this.roomInfo.floor = item.roomDescriptiveInfo.floor
      }
      else {
        this.roomInfo.floor = this.$t("DETAIL.NA")
      }
      if (item.roomDescriptiveInfo.name.en) {
        this.roomInfo.bedTypeEn = item.roomDescriptiveInfo.name.en
      }
      else { this.roomInfo.bedTypeEn = this.$t("DETAIL.NA") }
      if (item.roomDescriptiveInfo.name["zh-CN"]) {
        this.roomInfo.bedTypeCh = item.roomDescriptiveInfo.name["zh-CN"]
      }
      else { this.descriptionCh = this.$t("DETAIL.NA") }
    },
    NonCancellableMessage(item, list){
      this.NonCancellableRemark="";
      if(list.cancellationPolicy==0)
      {
        this.NonCancellabledialog=true;
        this.NonCancellableItem=item;
        this.NonCancellableList=list;
        this.NonCancellableRemark=this.$objBaseInfo.loginID+"已点击确认预定不可取消按钮";
      }
      else
      {
        this.toBooking(item, list);
      }
    },
    // 跳转booking
    toBooking: function (item, list) {
      console.log("预订参数：", list);
      this.NonCancellabledialog = false;
      this.$objBaseInfo.defaultCurrencyCode = list.currencyCode;
      this.$objBaseInfo.defaultCurrencySign = this.$currencySign[this.$objBaseInfo.defaultCurrencyCode];

      this.toBookingParams.hotelInfo.roomName = item.roomDescriptiveInfo.name; //房型名称 ["zh-CN"]
      // this.toBookingParams.hotelInfo.roomNameEn = item.roomDescriptiveInfo.name.en;
      this.toBookingParams.hotelInfo.hasWindow = parseInt(
        item.roomDescriptiveInfo.hasWindow
      ); //是否有窗
      this.toBookingParams.hotelInfo.floor = item.roomDescriptiveInfo.floor; //楼层
      this.toBookingParams.hotelInfo.area = item.roomDescriptiveInfo.area; //面积
      this.toBookingParams.hotelInfo.wifi = parseInt(
        item.roomDescriptiveInfo.wifi
      ); //wifi
      this.bookingCreateParam.hotelInfo = this.toBookingParams.hotelInfo;
      const hotelProperty = list;
      this.bookingCreateParam.isGuaranteeRequired = hotelProperty.isGuaranteeRequired;
      if (hotelProperty.isGuaranteeRequired) {
        // 担保 获取担保类型
        if(hotelProperty.guaranteeRules.length > 0)
        {
          switch(hotelProperty.guaranteeRules[0].type)
          {
            case "full":
              this.bookingCreateParam.guaranteeRules=1;
            break;
            case "first":
              this.bookingCreateParam.guaranteeRules=2;
            break;
            case "deposit":
              this.bookingCreateParam.guaranteeRules=5;
              
            break;
          }
        }
      } else {
        this.bookingCreateParam.guaranteeRules = 3;
      }
      //支持的信用卡
      this.bookingCreateParam.supportedCreditCards = hotelProperty.supportedCreditCards;
      this.bookingCreateParam.bookingType = hotelProperty.bookingType; //预订类型
      this.bookingCreateParam.cancellationPolicy = hotelProperty.cancellationSettings;
      this.bookingCreateParam.cancellationPolicy.type = hotelProperty.cancellationPolicy;
      //取消政策
      if (this.bookingCreateParam.cancellationPolicy.deadlineDay == 0) {
        this.bookingCreateParam.cancellationPolicy.cancellationDate = formatDateTime(this.postdate1, "YYYY-MM-DD");
      } else {
        this.bookingCreateParam.cancellationPolicy.cancellationDate =
          dateChange(
            parseInt(
              "-" + this.bookingCreateParam.cancellationPolicy.deadlineDay
            ),
            formatDateTime(this.postdate1, "YYYY-MM-DD")
          );
      }
      this.bookingCreateParam.rdescription = hotelProperty.rdescription; //协议价格code
      this.bookingCreateParam.RateAccessCode = hotelProperty.rateAccessCode; //协议价格code
      this.bookingCreateParam.RatePlanCode = hotelProperty.ratePlanCode; //价格计划ID
      this.bookingCreateParam.ratePlanName = hotelProperty.ratePlanName; //价格计划名称
      this.bookingCreateParam.source = hotelProperty.source; //价格计划所属 channel
      this.bookingCreateParam.paymentType = hotelProperty.paymentType; //付款类型
      this.bookingCreateParam.priceType = hotelProperty.priceType; //0=协议价, 1=非协议价
      this.bookingCreateParam.priceOwner = hotelProperty.priceOwner;
      this.bookingCreateParam.breakfastNum = hotelProperty.breakfastInfo.quantity; //早餐
      this.bookingCreateParam.isOutOfPolicy = hotelProperty.isOutOfPolicy; //是否超标
      this.bookingCreateParam.taxes = hotelProperty.taxes;//总税费
      this.bookingCreateParam.fees = hotelProperty.fees;//费用合计
      this.bookingCreateParam.groupId = this.toBookingParams.groupId;
      this.bookingCreateParam.isIntegral= hotelProperty.isIntegral;

      if (hotelProperty.outOfPolicyReasons.length > 1) {
        this.bookingCreateParam.outOfPolicyReasons = 3;
      } else if (hotelProperty.outOfPolicyReasons[0] === "star") {
        this.bookingCreateParam.outOfPolicyReasons = 1;
      } else {
        this.bookingCreateParam.outOfPolicyReasons = 2;
      }
      this.bookingCreateParam.totalPrice = 0;
      this.bookingCreateParam.originData = [];
      this.bookingCreateParam.dailyPrices = [];
      for (const element of hotelProperty.prices) {
        let price = {
          date: element.date,
          price: this.$objBaseInfo.defaultCurrencySign + element.publishedFare,
        };
        
        // if (this.$objBaseInfo.destinationType == "I" || this.$objBaseInfo.isGATCity) {
        //   if (element.taxAmount && element.taxAmount.amount) {
        //     price.tax = this.$currencySign[element.taxAmount.currencyCode] + element.taxAmount.amount;
        //   }
        //   if (element.feeAmount && element.feeAmount.amount) {
        //     price.fee = this.$currencySign[element.feeAmount.currencyCode] + element.feeAmount.amount;
        //   }
        // }
        this.bookingCreateParam.originData.push(price);
        this.bookingCreateParam.totalPrice += parseFloat(element.publishedFare);
        let daily = {
          StayDate: element.date,
          Price: element.amount,
          CurrencyCode: this.$objBaseInfo.defaultCurrencyCode,// 取全局
          PublishedFare: element.publishedFare,
          // Taxs: {
          //   Amount: element && element.taxAmount && element.taxAmount.amount ? element.taxAmount.amount.toString() : null,
          //   CurrencyCode: element && element.taxAmount ? element.taxAmount.currencyCode : null,
          // },
          // OtherFees: {
          //   Amount: element && element.feeAmount && element.feeAmount.amount ? element.feeAmount.amount.toString() : null,
          //   CurrencyCode: element && element.feeAmount ? element.feeAmount.currencyCode : null,
          // },
        };
        this.bookingCreateParam.dailyPrices.push(daily);
      }
      this.bookingCreateParam.roomTypeCode = item.roomDescriptiveInfo.id;
      let priceCalendar = [];
      for (const iterator of list.prices) {
        priceCalendar.push({
          date: iterator.date,
          amount: iterator.amount,
          breakfastQty: iterator.breakfastQty,
          publishedFare: iterator.publishedFare,
        });
      }
      if(hotelProperty.priceType ==1)
      {
        this.priceTripRuleType = 2; //other
      }else if(hotelProperty.priceType == 0){
        if(hotelProperty.priceOwner =='cwt'){
          this.priceTripRuleType = 0; //ap
        }else if(hotelProperty.hasOwnProperty("negotiationPriceType") && hotelProperty.negotiationPriceType=="ratio" ){
          this.priceTripRuleType = 3;//chainwide
        }else{
          this.priceTripRuleType = 1; //cp
        }
      }
      this.bookingCreateParam.priceTripRuleType = this.priceTripRuleType;//验证差规协议价格类型
      this.bookingCreateParam.beforeTaxAmountTotal = hotelProperty.beforeTaxAmountTotal;//税前价格总计
      let params = {
        posCode: this.$objBaseInfo.poscode,
        hotelCode: this.toBookingParams.hotelcode,
        roomTypeCode: item.roomDescriptiveInfo.id,
        ratePlanCode: list.ratePlanCode,
        checkInDate: formatDateTime(this.postdate1, "YYYY-MM-DD"),
        checkOutDate: formatDateTime(this.postdate2, "YYYY-MM-DD"),
        priceCalendar: priceCalendar,
        paymentType: list.paymentType,
        priceType: this.bookingCreateParam.priceType,
        noRooms: this.toBookingParams.noRooms,
        noGuests: this.toBookingParams.noGuests,
        currencyCode: this.$objBaseInfo.defaultCurrencyCode,
        bookingContactId: this.$objBaseInfo.loginID,
        provinceCode: this.$objBaseInfo.provinceCode, //省份code
        isDomestic: this.$objBaseInfo.destinationType == "D" ? true : false, //是否是国内
        priceTripRuleType: this.priceTripRuleType,
        source:this.bookingCreateParam.source,
        remark:this.NonCancellableRemark,
        standardStar:this.bookingCreateParam.hotelInfo.standardStar,
      }
      if(hotelProperty.hasOwnProperty("negotiationPriceType"))
      {
        this.bookingCreateParam.negotiationPriceType = hotelProperty.negotiationPriceType;
      }
      if(hotelProperty.hasOwnProperty("isNeedCvv"))
      {
        this.bookingCreateParam.isNeedCvv = hotelProperty.isNeedCvv;
      }
      if(this.toBookingParams.hasOwnProperty("cwtMark"))
      {
        if(this.toBookingParams.cwtMark!=undefined && this.toBookingParams.cwtMark!=null)
        {
          this.bookingCreateParam.cwtMark = this.toBookingParams.cwtMark;
        }
      }
      this.$parent.allLoading = true;
      
      bookingsPropertyRate(params).then((res) => {
        this.$emit("setLoading", false);
        if (res.code == 200) {
          if (res.data.hasOwnProperty("isOutOfPolicy")) {
            this.bookingCreateParam.isOutOfPolicy = res.data.isOutOfPolicy;
          }
          this.bookingCreateParam.roomTypeDescription = res.data.roomTypeDescription?res.data.roomTypeDescription:"";
          if(this.bookingCreateParam.roomTypeDescription!= "" && this.bookingCreateParam.roomTypeDescription!=null && this.bookingCreateParam.roomTypeDescription!=undefined)
          {
               this.bookingCreateParam.rdescription = this.bookingCreateParam.roomTypeDescription; //协议价格code
          }
          if (res.data.hasOwnProperty("productCode")) {
            this.bookingCreateParam.productCode = res.data.productCode;
          }
          this.bookingCreateParam.breakfastFlag = res.data.breakfastFlag?Boolean(res.data.breakfastFlag):false;
          this.bookingCreateParam.breakfast = res.data.breakfast == null ? null : Boolean(res.data.breakfast);
          this.bookingCreateParam.breakfastDescription = res.data.breakfastDescription == null ? '' : res.data.breakfastDescription;
          if (res.data.isOutOfPolicy) {
            //不允许预订 提示超标信息
            let star = "";
            let amount = "";
            var negotiationPrice = false ;
            let cwtTrip = false;
            this.outMsg = "";
            for (const item of res.data.outOfPolicyReasons) {
              if (item.key == "amountTopLimit") {
                amount = item.value;
              }
              else if(item.key == "NegotiationPrice"){
                negotiationPrice = true;
              }
              else if(item.key == "cwtTrip"){
                  cwtTrip = true;
              } 
              else {
                star = item.value;
              }
            }
            if (star != "") {
              this.outMsg += this.$t("BOOKING.EXCEEDEDPSTAR", {
                star: star,
              });
            }
            else if (amount != "") {
              if(Object.prototype.hasOwnProperty.call(res.data, "rawOverStandardRules")) 
              {
                let rawAmountTopLimit='';
                let rawCurrencyCode='';
                for (const item of res.data.rawOverStandardRules) {
                  if (item.key == "amountTopLimit") {
                    rawAmountTopLimit = item.value;
                  }else if(item.key == "currencyCode"){
                    rawCurrencyCode = item.value;
                  }
                }
                if(rawAmountTopLimit!='' && rawCurrencyCode!='')
                {
                  this.outMsg += this.$t("BOOKING.EXCEEDEDPRICE", {
                    price: this.$currencySign[rawCurrencyCode] + rawAmountTopLimit,
                  });
                }
                else
                {
                    this.outMsg += this.$t("BOOKING.EXCEEDEDPRICE", {
                      price: this.$objBaseInfo.defaultCurrencySign + amount,
                    });
                }
              }
              else
              {
                  this.outMsg += this.$t("BOOKING.EXCEEDEDPRICE", {
                    price: this.$objBaseInfo.defaultCurrencySign + amount,
                  });
              }
            }
            else if (cwtTrip) {
                this.outMsg = this.$t("RESULT.OUTOFPOLICYTIPEMPTY");
            }
            if(negotiationPrice){
              this.outMsg += (amount != "" ?"<br />":"" ) + this.$t('RESULT.OUTOFPOLICYTIP3');
            }
          }
          if (res.data.error.code != 0) {
            if (res.data.error.code == 10901) {
              //库存不足
              this.errorMessage = this.$t("ERRORMESSAGE." + res.data.error.code)
              this.dialogRefresh = true;
            } else if (res.data.error.code == 10902) {
              //价格变化
              if (
                (res.data.isOutOfPolicy && res.data.bookingIsAllowed) ||
                !res.data.isOutOfPolicy
              ) {
                if (res.data.isOutOfPolicy) {
                  this.isJugeOut = true;
                } else {
                  this.isJugeOut = false;
                }
                let isPublicChange = false; //是否是publishedFare变化
                this.newPriceCalendar = res.data.priceCalendar;
                for (const price of priceCalendar) {
                  let priceNew = res.data.priceCalendar.find((newPrice) => {
                    if (
                      newPrice.date == price.date &&
                      newPrice.publishedFare != price.publishedFare
                    ) {
                      return newPrice;
                    } else {
                      return null;
                    }
                  });
                  if (priceNew) {
                    isPublicChange = true;
                    this.newAmount = this.$objBaseInfo.defaultCurrencySign + priceNew.publishedFare;
                    this.originAmount = this.$objBaseInfo.defaultCurrencySign + price.publishedFare;
                    break;
                  }
                }
                //需要判断价格变化是amount  还是publishedFare
                if (isPublicChange) {
                  //不超标 、超标可以预订
                  this.dialogProceed = true;
                } else {
                  this.toBookingPriceChange("change");
                }
              } else {
                this.confirmFlag = true;
                this.confirmMsg = this.$t("RESULT.OUTOFPOLICYTIPAdd",{outOfPolicy: this.outMsg});
              }
            } else {
              this.confirmFlag = true;
              this.confirmMsg = this.$t("ERRORMESSAGE." + res.data.error.code) === "ERRORMESSAGE." + res.data.error.code ? this.$t("ERRORMESSAGE.NOTFOUND") : this.$t("ERRORMESSAGE." + res.data.error.code);
              console.log("bookings property rate 请求失败, code:" + res.data.error.code, res.data.code.message);
            }
          } else {
            //判断是否超标
            if (res.data.isOutOfPolicy) {
              if(this.$objBaseInfo.sourceType == "OBT") {
                if (res.data.bookingIsAllowed) {
                //超标允许预订
                this.dialogOut = true;
                } else {
                this.confirmFlag = true;
                this.confirmMsg = this.$t("RESULT.OUTOFPOLICYTIPAdd",{outOfPolicy: this.outMsg});
                }
              }
              else{
                if (res.data.bookingIsAllowed || res.data.enableAgentOutOfPolicyControl) {
                  //超标允许预订
                  this.dialogOut = true;
                } else{
                  this.confirmFlag = true;
                  this.confirmMsg = this.$t("RESULT.OUTOFPOLICYTIPAdd",{outOfPolicy: this.outMsg});
                }
              }
            } else {
              //未超标
              let createOrder = {
                isOut: false,
                roomTypeId: item.roomDescriptiveInfo.id,
                hotelcode: this.toBookingParams.hotelcode,
                checkInAt: this.postdate1,
                checkOutAt: this.postdate2,
                roomCount: this.toBookingParams.noRooms, //房间数
                guestCount: this.toBookingParams.noGuests,
                bookingCreateParam: this.bookingCreateParam,
              };
              sessionStorage.setItem("createOrder", JSON.stringify(createOrder));
              this.$router.push({
                path: "/booking",
                query: { sourceType: this.$objBaseInfo.sourceType },
              });
            }
          }
        }
        else {
          this.confirmFlag = true;
          this.confirmMsg = this.$t("ERRORMESSAGE." + res.code) === "ERRORMESSAGE." + res.code ? this.$t("ERRORMESSAGE.NOTFOUND") : this.$t("ERRORMESSAGE." + res.code);
          console.log("bookings property rate 请求失败, code:" + res.code, res.message);
        }
      }).catch(function (error) {
        //this.$emit("setLoading", false);
        this.confirmFlag = true;
        this.confirmMsg = this.$t("ERRORMESSAGE." + error.mesCode);
        console.log("bookings property rate 请求失败", error.objError);
      });
    },
    toBookingPriceChange(type) {
      if (this.dialogProceed || type == "change") {
        //价格超标 不需要重新赋值间夜价格
        let oldStayPrice = this.bookingCreateParam.dailyPrices;
        this.dialogProceed = false;
        this.bookingCreateParam.totalPrice = 0;
        this.bookingCreateParam.originData = [];
        this.bookingCreateParam.dailyPrices = [];
        for (const element of this.newPriceCalendar) {
          let tax = oldStayPrice.find(
            (oldprice) => oldprice.date === element.date
          );
          let price = {
            date: element.date,
            price: this.$objBaseInfo.defaultCurrencySign + element.publishedFare,
          };
          if (this.$objBaseInfo.destinationType == "I" || this.$objBaseInfo.isGATCity) {
            if (tax && tax.taxAmount.amount) {
              price.tax = this.$currencySign[tax.taxAmount.currencyCode] + tax.taxAmount.amount;
            }
            if (tax && tax.feeAmount.amount) {
              price.fee = this.$currencySign[tax.feeAmount.currencyCode] + tax.feeAmount.amount;
            }
          }
          this.bookingCreateParam.originData.push(price);
          this.bookingCreateParam.totalPrice += parseFloat(element.publishedFare);
          let daily = {
            StayDate: element.date,
            Price: element.amount,
            CurrencyCode: this.$objBaseInfo.defaultCurrencyCode,
            PublishedFare: element.publishedFare,
            // Taxs: {
            //   Amount: tax && tax.taxAmount && tax.taxAmount.amount ? tax.taxAmount.amount.toString() : null,
            //   CurrencyCode: tax && tax.taxAmount ? tax.taxAmount.currencyCode : null,
            // },
            // OtherFees: {
            //   Amount: tax && tax.feeAmount && tax.feeAmount.amount ? tax.feeAmount.amount.toString() : null,
            //   CurrencyCode: tax && tax.feeAmount ? tax.feeAmount.currencyCode : null,
            // },
          };
          this.bookingCreateParam.dailyPrices.push(daily);
        }
      }
      let isOut = this.isJugeOut;
      if (this.isJugeOut) {
        this.isJugeOut = false;
        this.dialogOut = true;
        return false;
      }
      this.dialogOut = false;
      let createOrder = {
        isOut: isOut,
        roomTypeId: this.bookingCreateParam.roomTypeCode,
        hotelcode: this.toBookingParams.hotelInfo.hotelcode,
        checkInAt: this.postdate1,
        checkOutAt: this.postdate2,
        roomCount: this.toBookingParams.noRooms, //房间数
        guestCount: this.toBookingParams.noGuests,
        bookingCreateParam: this.bookingCreateParam,
      };
      sessionStorage.setItem("createOrder", JSON.stringify(createOrder));
      this.$router.push({
        path: "/booking",
        query: { sourceType: this.$objBaseInfo.sourceType },
      })
    },
    refresh() {
      this.dialogOut = false;
      this.dialogRefresh = false;
      this.dialogProceed = false;
      this.NonCancellabledialog = false;
      this.getRoomType();
    },
    showDescription(description){
      this.confirmIcon = "exclamation";
      this.confirmMsg = description;
      this.confirmFlag = true;
    },
    ChainwidePrice(value){
      if(value.hasOwnProperty("negotiationPriceType"))
      {
        if(value.negotiationPriceType=="ratio")
        {
          return this.$t('DETAIL.ChainwidePrice')
        }
      }
      return "";
    },
    checkpaymentType(){      
      if(this.$objBaseInfo.openResource){
        var data = JSON.parse(this.$objBaseInfo.openResource);
        if (this.$objBaseInfo.destinationType === "I"){
          if(data.International.includes("2"))//国际是否开启预付
          {
            this.isPrepay = true;
            this.filterList.push({ value: 11, label: { "zh-CN": "在线付", en: "Online Pay" }});
          }
          if(data.International.includes("3"))//国际是否开启公付
          {
            this.isPublicPay = true;
            this.filterList.push({ value: 9, label: { "zh-CN": "公付", en: "CompanyPay" }});
          }
          if(data.International.includes("1"))//国际是否开启现付
          {
            this.filterList.push({ value: 10, label: { "zh-CN": "前台现付", en: "Pay At Hotel" }});
          }
        }else if (this.$objBaseInfo.destinationType === "D"){
          if(isCityGAT(this.$route.query.cwtCityCode)){
            if(data.GangAoTai.includes("2")){//港澳台是否开启预付
              this.isPrepay = true;
              this.filterList.push({ value: 11, label: { "zh-CN": "在线付", en: "Online Pay" }});
            }
            if(data.GangAoTai.includes("3")){//港澳台是否开启公付
              this.isPublicPay = true;
              this.filterList.push({ value: 9, label: { "zh-CN": "公付", en: "CompanyPay" }});
            }
            if(data.GangAoTai.includes("1"))//港澳台是否开启现付
            {
              this.filterList.push({ value: 10, label: { "zh-CN": "前台现付", en: "Pay At Hotel" }});
            }
          }else{
            if(data.Domestic.includes("2")){//大陆是否开启预付
              this.isPrepay = true;
              this.filterList.push({ value: 11, label: { "zh-CN": "在线付", en: "Online Pay" }});
            }
            if(data.Domestic.includes("3")){//大陆是否开启公付
              this.isPublicPay = true;
              this.filterList.push({ value: 9, label: { "zh-CN": "公付", en: "CompanyPay" }});
            }
            if(data.Domestic.includes("1"))//大陆是否开启现付
            {
              this.filterList.push({ value: 10, label: { "zh-CN": "前台现付", en: "Pay At Hotel" }});
            }
          }
        }
      }
      if(this.$objBaseInfo.showTravelTitle && this.$objBaseInfo.displayTravelRules){
        this.filterList.push({ value: 14, label: { "zh-CN": "符合政策", en: "In Policy" }});
      }
    },
    filterChange(){
      this.filterRoomTypeList();
      this.originData = (JSON.parse(JSON.stringify(this.newRoomTypeList))).map(item => {
        let newItem = { ...item }
        if (item.ratePlans && item.ratePlans.length > 0) {
          newItem.ratePlans = [item.ratePlans[0]];
        }
        return newItem;
      })
    },
    filterRoomTypeList(){
      this.showTag = true;
      if(this.$objBaseInfo.channelId !== 'WEB' && !this.$objBaseInfo.onlyShowBestPrice){
        this.$refs.location.toggle(false);
      }
      this.newRoomTypeList = this.roomTypeList.map((item) => {
        // 定义 ratePlans 的过滤函数
        const filters = {
          1: ratePlan => ratePlan.breakfastInfo.quantity > 0,
          2: ratePlan => ratePlan.priceType === 0 && ratePlan.priceOwner !== '' && ratePlan.priceOwner !== 'cwt',
          3: ratePlan => ratePlan.bookingType === 'normal',
          4: ratePlan => ratePlan.cancellationPolicy !== 0,
          12: ratePlan => parseFloat(ratePlan.averagePrice) >= this.minNumber,
          13: ratePlan => parseFloat(ratePlan.averagePrice) <= this.maxNumber,
          14: ratePlan => ratePlan.isOutOfPolicy===false,
          15: ratePlan => ratePlan.isBestPrice===true,
        };
        this.showFilter = false;
        if(this.filterGroup.includes(15)){
          this.filterGroup = this.filterGroup.filter(item => item === 15);
          this.showFilter = true;
        }
        // 过滤 ratePlans
        const filteredRatePlans = item.ratePlans.filter(ratePlan => {
            const allConditionsMet = this.filterGroup.every(condition => {
                const filterFunction = filters[condition];
                return filterFunction ? filterFunction(ratePlan) : true; // 默认满足条件
            });
            return allConditionsMet;
        });
        let newRatePlans = filteredRatePlans;
        // 根据 filterGroup 进一步筛选 ratePlans 支付方式
        if (this.filterGroup.includes(9) || this.filterGroup.includes(10) || this.filterGroup.includes(11)) {
          newRatePlans = newRatePlans.filter(ratePlan => {
              // 如果包含 9、10 或 11，则检查相应的支付类型
              return (
                (this.filterGroup.includes(9) && ratePlan.paymentType === 3) ||
                (this.filterGroup.includes(10) && ratePlan.paymentType === 1) ||
                (this.filterGroup.includes(11) && ratePlan.paymentType === 2)
              );
          });
        }
        // 根据 filterGroup 进一步筛选 ratePlans 担保方式
        if (this.filterGroup.includes(5) || this.filterGroup.includes(6)) {
          newRatePlans = newRatePlans.filter(ratePlan => {
              return (
                (this.filterGroup.includes(5) && ratePlan.isGuaranteeRequired) ||
                (this.filterGroup.includes(6) && !ratePlan.isGuaranteeRequired)
              );
          });
        }
         // 处理 roomDescriptiveInfo 的过滤
         const roomDescriptiveInfo = item.roomDescriptiveInfo;
        if (this.filterGroup.includes(8) || this.filterGroup.includes(7)) {
            const bedTypeCode = roomDescriptiveInfo.bedTypeCode;
            newRatePlans = newRatePlans.filter(ratePlan => {
              return ((this.filterGroup.includes(8) && bedTypeCode === "BT01") ||
              (this.filterGroup.includes(7) && bedTypeCode === "BT02") ||
              bedTypeCode === "BT17");
            });
        }
        // 客户开启在线付和公付，过滤掉在线付
        if(this.isPrepay && this.isPublicPay && this.filterGroup.includes(15)){
          newRatePlans = newRatePlans.filter(ratePlan => {
            return ratePlan.paymentType != 2;
          });
        }
        if(this.filterGroup.includes(16)){
          newRatePlans = newRatePlans.filter(ratePlan => ratePlan.isIntegral === true);
        }
        if(this.filterGroup.includes(15)){
          newRatePlans.sort((a, b) => {
            return a.bestPriceSort - b.bestPriceSort;
          });
        }
        if(this.showTag){
          this.showTag = newRatePlans.length >0 ? false: true;
        }
        // 仅当满足条件时才保留该条数据
        return {
          ...item,
          ratePlans: newRatePlans,
        };
      }).filter(item => item !== null); // 移除不满足条件的条目
      console.log(this.newRoomTypeList);
    },
    handlePriceRangeChange(type){
      switch (type) {
        case 2:
          this.minNumber = 0;
          this.maxNumber = 300;
          this.filterGroup.push(12);
          this.filterGroup.push(13);
          break;
        case 3:
          this.minNumber = 300;
          this.maxNumber = 500;
          this.filterGroup.push(12);
          this.filterGroup.push(13);
          break;
        case 4:
          this.minNumber = 500;
          this.maxNumber = 1000;
          this.filterGroup.push(12);
          this.filterGroup.push(13);
          break;
        case 5:
          this.minNumber = 1000;
          for (let i = this.filterGroup.length - 1; i >= 0; i--) {
            if (this.filterGroup[i] === 13) {
              this.filterGroup.splice(i, 1);
            }
          }
          this.filterGroup.push(12);
          break;
        case 6:
          this.minNumber = "";
          this.maxNumber = "";
          this.showCustomizePriceRange = true;
          break;
        default:
          for (let i = this.filterGroup.length - 1; i >= 0; i--) {
            if (this.filterGroup[i] === 12 || this.filterGroup[i] === 13) {
              this.filterGroup.splice(i, 1);
            }
          }
          break;
      }
      if(type != 6){
        this.filterRoomTypeList();
      }
    },
    clearNoNumPriceRangeFrom(){
      this.minNumber = this.minNumber.replace(/[^\d.]/g, "");  //清除“数字”和“.”以外的字符
      this.minNumber = this.minNumber.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
      this.minNumber = this.minNumber.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      this.minNumber = this.minNumber.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');//只能输入两个小数
      this.minNumber = this.minNumber.replace(/^0+\./g, '0.').replace(/^0+([0-9])/, '$1');  //清除.前面无效的0
      if (this.minNumber.indexOf(".") < 0 && this.minNumber != "") {//以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        this.minNumber = parseFloat(this.minNumber);
      }
    },
    clearNoNumPriceRangeTo(){
      this.maxNumber = this.maxNumber.replace(/[^\d.]/g, "");  //清除“数字”和“.”以外的字符
      this.maxNumber = this.maxNumber.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
      this.maxNumber = this.maxNumber.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      this.maxNumber = this.maxNumber.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');//只能输入两个小数
      this.maxNumber = this.maxNumber.replace(/^0+\./g, '0.').replace(/^0+([0-9])/, '$1');  //清除.前面无效的0
      if (this.maxNumber.indexOf(".") < 0 && this.maxNumber != "") {//以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        this.maxNumber = parseFloat(this.maxNumber);
      }
    },
    searchPriceRange(){
      this.showCustomizePriceRange = false;
      const removeItemFromGroup = (item) => {
        this.filterGroup = this.filterGroup.filter(groupItem => groupItem !== item);
      };
     
      if (!this.filterGroup.includes(12)) this.filterGroup.push(12);
      if (!this.filterGroup.includes(13)) this.filterGroup.push(13);
      if (this.maxNumber != "" && this.minNumber != ""){
        this.priceArea = this.minNumber + "," + this.maxNumber;
        this.priceAreaValue = this.priceArea.replace(",", "-");
        this.priceRangeTitle = this.priceArea.replace(",", "-");
      } else if (this.maxNumber == "" && this.minNumber == ""){
        this.priceArea = "";
        this.priceAreaValue = this.priceArea;
        this.priceRangeTitle = this.priceArea;
      }else if (this.maxNumber == ""){
        removeItemFromGroup(13);
        this.priceArea = this.minNumber.toString();
        this.priceAreaValue = this.$t("RESULT.PRICERANGE7", {
          priceRange: this.priceArea,
          });
        this.priceRangeTitle = this.$t("RESULT.PRICERANGE7", {
          priceRange: this.priceArea,
          });
      }else{
        this.priceArea =  "0," + this.maxNumber;
        this.priceAreaValue = this.priceArea.replace(",", "-");
        this.priceRangeTitle = this.priceArea.replace(",", "-");
      }
      this.filterRoomTypeList();
    },
    priceRangeClose(newVal){
      if(newVal == 6 && !this.showCustomizePriceRange){
        this.showCustomizePriceRange = true;
      }
    },
    h5FilterClick(item){
      if(!this.filterGroup.includes(15)){
        const index = this.filterGroup.indexOf(item.value);
        if (index === -1) {
          this.filterGroup.push(item.value);
        } else {
          this.filterGroup.splice(index, 1);
        }
      }
    },
    onTreeReset(){
      this.filterGroup = this.filterGroup.filter(item => item === 12 || item === 13);
      this.bestPriceChecked = false;
    },
    toHotelList(){
      var cityInfo = {
        cityCode: this.toBookingParams.hotelInfo.city,
        cityInfo:{
          countryCode: this.toBookingParams.hotelInfo.countryCode
        }
      };
      let searchParam = {
        city: cityInfo,
        checkInAt: this.toBookingParams.checkInDate,
        checkOutAt: this.toBookingParams.checkOutDate,
        roomCount: this.toBookingParams.noRooms,
        guestCount: this.toBookingParams.noGuests,
        keyword: '',
        keywordType: '',
        centerPointHotelId: this.toBookingParams.hotelcode,
      };
      sessionStorage.removeItem('resultData');
      // result 页面  map:  页面
      // 跳转页面
      this.$store.commit("changePathQuery", searchParam);
      this.$router.push({
        name: 'Result',
        query: {
          searchParam: JSON.stringify(searchParam),
          sourceType: this.$objBaseInfo.sourceType,
        },
      });
    },
    bestPriceCheckedChange(){
      const index = this.filterGroup.indexOf(15);
      if (index !== -1) {
        this.filterGroup.splice(index, 1);
      } 
      if(this.bestPriceChecked){
        this.filterGroup.push(15);
        this.filterGroup = this.filterGroup.filter(item => item === 15);
      }
    },
    GetGuaranteeTooltip(item) {
      let content = "";
      let depositContent = "";
      
      if (item.isGuaranteeRequired == true) {
        if (item.guaranteeRules[0].type == "deposit") {
          depositContent = this.$t('EGuarantee.SabreDetailTIPMSGDeposit');
        }
      }

      if (item.source == 'elong' && item.paymentType == 1) {
        content = this.$t('EGuarantee.DetailTIPMSG');
      }
      if ((item.source.indexOf("sabre") >= 0 || item.source.indexOf("booking") >= 0) && item.paymentType == 1 && item.cancellationPolicy == 0) {
        content = this.$t('EGuarantee.SabreDetailTIPMSG');
      }
      
      if (!content || !depositContent) {
        return depositContent + content;
      } else {
        return depositContent + ',' + content;
      }
    },
    getWifiText(wifiValue) {
      const wifiMap = {
        0: this.$t("COMMONPARAM.WIFI.WIFI0"),
        1: this.$t("COMMONPARAM.WIFI.WIFI1"),
        2: this.$t("COMMONPARAM.WIFI.WIFI2"),
        3: this.$t("COMMONPARAM.WIFI.WIFI3")
      };
      return wifiMap[wifiValue] || '';
    },
    RoomDetailText1(list) {
      // 早餐信息映射
      const breakfastMap = {
        0: this.$t("DETAIL.linshi2"),
        99: this.$t("DETAIL.HASBREAKFAST")
      };
      
      // 取消政策映射
      const cancellationMap = {
        0: this.$t("DETAIL.CANCELLATIONPOLICY0"),
        1: this.$t("DETAIL.CANCELLATIONPOLICY1"),
        2: this.$t("DETAIL.CANCELLATIONPOLICY2")
      };
      
      // 获取早餐文本
      const breakfastText = breakfastMap[list.breakfastInfo.quantity] || 
        (this.$t("DETAIL.BREAKFAST") + " x " + list.breakfastInfo.quantity);
      
      // 获取取消政策文本
      const cancellationText = cancellationMap[list.cancellationPolicy] || '';
      
      // 返回拼接结果
      return `${breakfastText}<span style="color: #999; margin: 0 4px;">|</span>${cancellationText}`;;
    },
  },
  imgClass: {
    "background-repeat": "no-repeat",
    "background-size": "cover",
    "background-position": "center center",
    width: "100%",
    height: "100%",
  },
};
</script>
<style lang="stylus" scoped>
.room-photo-image,
.room-photo-image :deep(.el-image__inner) {
  width: 100%;
  height: 100%;
  display: block;
}

/* 电脑屏幕 */
@media screen and (min-width: 961px) {

  .image-list-scroll {
    white-space: nowrap;
    overflow: auto;

    // display: flex;
    &::-webkit-scrollbar {
    }

    &::-webkit-scrollbar-track-piece { // 滚动条凹槽的颜色，还可以设置边框属性
      background-color: $scrollbar-bg-color;
      border-radius: 10px;
    }

    &::-webkit-scrollbar { // 滚动条的宽度
      width: 9px;
      height: 9px;
    }

    &::-webkit-scrollbar-thumb { // 滚动条的设置
      background-color: $scrollbar-thumb-color;
      background-clip: padding-box;
      min-height: 28px;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background-color: $scrollbar-thumb-hover-color;
    }
  }

  .image-carousel-right {
    word-break: break-word;
    min-width: 0;
  }

  .image-carousel-right ul li {
    width: 100%;
    max-width: 18rem;
    overflow-wrap: anywhere;
    text-transform: capitalize;
    float: left;
    margin-top: 1rem;
    span {
      display: block;
      padding-left: 4rem;
    }
  }

  .no_List {
    text-align: center;
    height: 6rem;
    line-height: 6rem;
    font-size: 1.5rem;
    background-color: $detail-table-title-bg;
  }

  .detail_list_title {
    display: flex;
    justify-content: space-around;
  }

  .detail_list_title_ul {
    border-bottom: 0.2rem solid $btn-bg-color;
    align-content: center;
    background-color: $detail-table-title-bg;

    .el-col {
      line-height: 2rem;
      text-align: center;
      // padding: 1.3rem 0;
      font-size: 1.4rem;
    }
  }

  .text-right {
    padding-left: 2.5rem;
    color: white;
  }

  .detail_list_title_li {
    height: 2rem;
    line-height: 2rem;
    text-align: center;
    padding: 1.3rem 0;
    font-size: 1.4rem;
    width: 10%;
  }

  .table_col_1 {
    width: 18.2rem;
  }

  .table_col_2, .table_col_5 {
    width: 8rem;
  }

  .table_col_6 {
    width: 10%;
  }

  .table_col_7, .table_col_8 {
    width: 10%;
  }

  .room_list_item {
    display: flex;
    border-bottom: 0.5rem solid #F1F3F5;
  }

  .room_pic {
    width: 18rem;
    height: 18rem;
    cursor: pointer;
  }

  .m_img {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    width: 100%;
    height: 100%;
  }

  .room_panel {
    text-align: center;
    font-size: 1.4rem;
    padding: 0 5px 0px 0px;
  }

  .room_name {
    padding-right: 5rem;
    margin: 1.3rem 0 1.4rem 0;
    // height: 2rem;
    line-height: 2rem;
    text-transform: capitalize;
    font-weight: 600;
  }
  .room_name_Inter
  {
    width: 20rem;/*要显示文字的宽度*/
    text-overflow: ellipsis;/*让截断的文字显示为点点。还有一个值是clip意截断不显示点点*/
    white-space: nowrap;/*让文字不换行*/
    overflow: hidden;/*超出要隐藏*/
  }
  .room_view {
    padding-right: 5rem;
    margin: 1.4rem 0 1.6rem 0;
  }

  .saleroomlist {
    width: 100%;
  }

  .saleroomlist_box {
    // margin: 2rem 3rem 0;
    // padding-bottom: 1rem;
  }

  .box_border:not(:last-child) {
    border-bottom: 0.1rem solid $bg-color;
  }

  .saleroomlist_dec {
    display: flex;
    // justify-content: space-between;
    align-items: center;

    .el-col {
      font-size: 1.2rem;
      line-height: 1.7rem;
      text-align: center;

      strong {
        font-size: 1.5rem;
        font-weight: normal;
      }
    }
  }

  .saleroomlist_dec_icon {
    width: 5 clrem;
  }

  .detail_icon {
    width: 2.4rem;
    height: 2.4rem;
    vertical-align: -0.6rem;
    cursor: pointer;
  }

  ul {
    li:hover {
      background-color: none;
    }
  }

  .select_btn {
    height: 3.5rem;
    width: 12rem;
    color: $btn-font-color;
    background: $btn-bg-color;
    border: 0px;
    border-radius: 3px;
    margin: 0px 20px 20px 0px;
    font-size: 1.4rem;

    &:hover {
      background-color: $btn-bg-color-hover;
    }

    &:active {
      background-color: $btn-bg-color-active;
    }
  }

  .li-payment-item {
    width: 10rem;
    height: 2.3rem;
    font-size: 1.2rem;
    line-height: 2.3rem;
    background: #F2A900;
    color: $btn-font-color;
    border-radius: 2px;
    padding: 0 1rem;
  }

  .bottom:not(:last-child) {
    margin-bottom: 1.3rem;
  }

  .price {
    font-size: 1.7rem;
    font-family: Source-Sans-Bold;
    margin: 20px 20px 20px 0px;
  }

  .type {
    font-size: 1rem;
    line-height: 1.4rem;
    color: $text-fill-color;
    width: 100%;
  }

  .li_view {
    div {
      text-align: right;
    }
  }

  .policy-content div {
    margin-bottom: 0.4rem;
  }

  .policy_outof_in_curr {
    display: inline-flex;
    justify-content: center;
    font-size: 1.2rem;
    font-weight: 500;
    text-transform: uppercase;
    width: 10rem;
    border-radius: 3px;
    margin: 20px 20px 0px 0px;

    &.policy_outof_color_curr {
      color: $warning-color;
      border: 0.1rem solid $warning-color;
    }

    &.policy_in_color_curr {
      color: $approval-color;
      border: 0.1rem solid $approval-color;
    }
  }

  .dialog_btn_y {
    background-color: $btn-bg-color;
    color: $btn-font-color;
    border: 0px;
    text-transform: uppercase;
    cursor: pointer;
    border-radius: 0.3rem;
    font-family: Source-Sans-Bold;
  }

  .d_confirm {
    ::v-deep .el-dialog__body, ::v-deep .el-dialog__footer {
      padding: 1rem 2rem;
    }

    ::v-deep .el-dialog__header {
      border-top: 4px solid $btn-bg-color;
    }
  }

  .d_confirm_refresh {
    ::v-deep .el-dialog__footer {
      text-align: right;
    }
  }

  .dialog-span-fixed {
    display: flex;

    .dialog-span-content {
      margin-left: 1rem;
    }
  }

  .table-title {
    padding: 1.3rem 0;
  }

  .dialog-image {
    margin-top: -10vh;
    
    ::v-deep .el-dialog {
      // height: 33.33vw;
      max-width: 90vw;
      max-height: 47.9rem;
    }
  }

  .room-image-dialog {
    ::v-deep .el-dialog__body {
      overflow: hidden;
    }
  }

  .showmore_content {
    margin-top: 1rem;
    height: 3rem;
    background: white;
  }

  .showmore_font {
    margin-top: 0.5rem;
    height: 2rem;
    font-size: 1.4rem;
    font-family: PingFang SC;
    cursor: pointer;
    color: #1061cc;
    line-height: 2rem;
  }

  .showmore_font:hover {
    color: #0a3d80;
  }

  .content_size {
    margin-left: 2rem !important;
    margin-right: 2rem !important;
  }

  .center_style {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .contact_font {
    width: 11.5rem;
    height: 2rem;
    font-size: 1.4rem;
    line-height: 2rem;
    color: #f2a900;
    padding-left: 7rem;
    padding-top: 1rem;
  }
  .delayClass{
    color: #FF694B;
  }
  .payment{
    width: 12rem;
  }
}

/* 手机、平板屏幕 */
@media screen and (max-width: 960px) {
  ::v-deep .el-col-17 {
    width: 100%;
  }
  .top-vant-btn {
    width: 45%;
    float: left;
    margin: 1rem;
  }
  .van-popup .van-tag--primary.van-tag--plain {
    margin: 1rem;
    display: inline-block;
    text-align: center;
    width: 8rem;
    padding: 1rem 2rem;
    font-size: 1.4rem;
    background: #eeeeee;
    color: #39393a;
  }
  .tagClass {
    display: flex!important;
    flex-wrap: wrap!important;
    align-items: center!important;
    padding-top: 5px!important;
    justify-content: flex-start!important;
  }

  /* 直接选中所有在 tagClass 下的 van-tag */
  .tagClass .van-tag--plain.van-tag--primary {
    margin:0!important;
    color: #999 !important;
    background: transparent !important;
    border-color: #999 !important;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    border: 1px solid #999 !important;
    border-radius: 4px !important;
    padding: 1px 5px;
    margin-right: 5px!important;
    font-size: 10px;
    font-family: 'Source-Sans-Pro-Regular';
  }
  .otherTagClass{
    padding:5px 0!important;
  }
  .otherTagClass .van-tag--plain.van-tag--primary {
    color: #222A30 !important;
    background: rgba(34, 42, 48, 0.1);
    font-size: 10px;
    padding: 1px 5px;
    border-radius: 4px !important;
    margin-left: 5px;
    font-family: 'Source-Sans-Pro-Regular';
  }
  .guarantee-content {
    display: flex;
    align-items: center;
  }

  .guarantee-icon {
    vertical-align: -0.5em;
    width: 1.5rem;
    height: 1.5rem;
    margin-left: 2px;
  }
  .van-button{
    height: 38px;
  }
  .van-tag--plain::before {
    border: 0px;
  }
  .click-dist-tag {
    background: #409eff !important;
    color: white !important;
  }
  ::v-deep .el-carousel__container {
    position: relative;
    width: 100%;
    height: 100%;
  }

  ::v-deep .el-carousel {
    width: 100%;
    height: 100%;
  }

  ::v-deep .el-image__inner {
    width: 100%;
    height: 100%;
  }

  ::v-deep .image-carousel-right ul li h3 {
    display: inline;
    font-size: 1.4rem;
    line-height: 2.5rem;
    margin-right: 1.3rem;
    margin-bottom: 2rem;
  }

  .roomBasic {
    margin-top: 2%;
    background: white;
    height: 30vw;
    padding-left: 1rem;
    padding-right: 2rem;
  }

  .middle {
    margin-left: 10%;
    wdith: 100%;
  }

  .roomDetail {
    margin: 0 auto;
    background: #fff;
    padding: 0 1rem 1rem 1rem;
  }

  .openBtn {
    float: right;
    margin-top: 2.5vw;
  }

  .left_part {
    font-size: 1.2rem;
    margin-top: 10%;
    margin-left: 5%;
    display: flex;
    flex-direction: column;
  }

  .center_part {
    margin-top: 10%;
    // margin-left: 10%;
    display: flex;
    flex-direction: column;
  }

  .right_part {
    // margin-right: 5%;
    // margin-left: 10%;
    display: flex;
    flex-direction: column;
    // padding-bottom: 5%;
  }

  // .image-carousel-right ul li {
  // width:16rem;
  // text-transform: capitalize;
  // }
  .image-carousel-right {
    font-family: PingFang SC;
    color: $btn-font-color;

    /* font-weight: 600; */
    ul {
      display: flex;
      flex-direction: column;

      li {
        line-height: 2rem;
        padding-bottom: 1.4rem;
        display: inline-block;
        width: 16rem;
        font-size: 1.2rem;
        text-transform: capitalize;

        h3 {
          display: inline;
          font-size: 1.8rem;
          /* font-weight: 600; */
          line-height: 2.5rem;
          margin-right: 1.3rem;
          margin-bottom: 2rem;
        }

        svg {
          padding-right: 1rem;
        }
      }
    }
  }

  .no_List {
    text-align: center;
    height: 6rem;
    line-height: 6rem;
    font-size: 1.5rem;
    background-color: $detail-table-title-bg;
  }

  .detail_list_title {
    display: flex;
    justify-content: space-around;
  }

  .detail_list_title_ul {
    border-bottom: 0.2rem solid $btn-bg-color;
    align-content: center;
    background-color: $detail-table-title-bg;

    .el-col {
      line-height: 2rem;
      text-align: center;
      // padding: 1.3rem 0;
      font-size: 1.4rem;
    }
  }

  .text-right {
    padding-left: -5%;
  }

  .detail_list_title_li {
    height: 2rem;
    line-height: 2rem;
    text-align: center;
    padding: 1.3rem 0;
    font-size: 1.4rem;
    width: 10%;
  }

  .table_col_1 {
    width: 18.2rem;
  }

  .table_col_2, .table_col_5 {
    width: 8rem;
  }

  .table_col_6 {
    width: 10%;
  }

  .table_col_7, .table_col_8 {
    width: 10%;
  }

  .room_list_item {
    display: flex;
    border-bottom: 0.5rem solid #F1F3F5;
  }

  .room_pic {
    // margin: 10%;
    margin-top: 2.5vw;
    width: 100%;
    height: 25vw;
    cursor: pointer;
  }

  .m_img {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    width: 100%;
    height: 100%;
  }

  .room_panel {
    text-align: center;
    font-size: 1.4rem;
    padding: 0 5px 0px 0px;
  }

  .room_name {
    font-size: 1.8rem;
    margin-top: 5%;
    text-transform: capitalize;
    font-weight: 600;
    font-family: 'Source-Sans-Pro-Semibold';
  }
  .room_name_Inter
  {
    //width: 15VW;/*要显示文字的宽度*/
    text-overflow: ellipsis;/*让截断的文字显示为点点。还有一个值是clip意截断不显示点点*/
    white-space: nowrap;/*让文字不换行*/
    overflow: hidden;/*超出要隐藏*/
  }
  .bedCount {
    font-weight: normal;
  }

  .peopleCount {
  }
  
  .peopleCount.en-style {
    display: flex;
    align-items: center;
    line-height: 1;
  }
  .room_view {
    padding-right: 5rem;
    margin: 1.4rem 0 1.6rem 0;
  }

  .saleroomlist {
    width: 100%;
  }

  .saleroomlist_box {
    // margin: 2rem 3rem 0;
    // padding-bottom: 1rem;
  }

  .box_border:not(:last-child) {
    border-bottom: 0.1rem solid $bg-color;
  }

  .saleroomlist_dec {
    display: flex;
    // justify-content: space-between;
    align-items: center;

    .el-col {
      font-size: 1.2rem;
      line-height: 1.7rem;
      text-align: center;

      strong {
        font-size: 1.5rem;
        font-weight: normal;
      }
    }
  }

  .saleroomlist_dec_icon {
    width: 5 clrem;
  }

  .detail_icon {
    width: 1.2rem;
    height: 1.2rem;
    cursor: pointer;
  }

  ul {
    li:hover {
      background-color: none;
    }
  }

  .all_btns {
    float: right;
    margin-left: auto;
  }

  .select_btn {
    height: 4rem;
    width: 12rem;
    color: $btn-font-color;
    background: $btn-bg-color;
    border: 0px;
    border-radius: 3px;
    font-size: 1.2rem;

    &:hover {
      background-color: $btn-bg-color-hover;
    }

    &:active {
      background-color: $btn-bg-color-active;
    }
    span {
      font-size: 17px;
      font-family: 'Source-Sans-Bold';
    }
  }

  .li-payment-item {
    width: 10rem;
    height: 2.3rem;
    font-size: 1.2rem;
    line-height: 2.3rem;
    background: unset;
    color: #F2A900;
    border-radius: 2px;
    text-align: left;
  }

  .bottom:not(:last-child) {
    margin-bottom: 1.3rem;
  }

  .price {
    font-size: 1.7rem;
    font-family: Source-Sans-Bold;
    margin: 1rem 0 1rem 0px;
    text-align: right;
    &.exchange-rate{
      font-size: 1.3rem;
      margin:0;
    }
  }

  .type {
    font-size: 1rem;
    line-height: 1.4rem;
    color: $text-fill-color;
    width: 100%;
  }

  .li_view {
    div {
      text-align: right;
    }
  }

  .policy-content div {
    margin-bottom: 1rem;
  }
  
  .policy_outof_in_curr {
    display: inline-flex;
    justify-content: center;
    font-size: 1.2rem;
    font-weight: 500;
    text-transform: uppercase;
    width: 10rem;
    border-radius: 3px;
    margin: 20px 20px 0px 0px;

    &.policy_outof_color_curr {
      color: $warning-color;
      border: 0.1rem solid $warning-color;
    }

    &.policy_in_color_curr {
      color: $approval-color;
      border: 0.1rem solid $approval-color;
    }
  }

  .dialog_btn_y {
    background-color: $btn-bg-color;
    color: $btn-font-color;
    border: 0px;
    text-transform: uppercase;
    cursor: pointer;
    border-radius: 0.3rem;
    font-family: Source-Sans-Bold;
  }

  .d_confirm {
    ::v-deep .el-dialog__body, ::v-deep .el-dialog__footer {
      padding: 1rem 2rem;
    }
  }

  .d_confirm_refresh {
    ::v-deep .el-dialog__footer {
      text-align: right;
    }
  }

  .dialog-span-fixed {
    display: flex;
    margin-top: 3rem;

    .dialog-span-content {
      margin-left: 1rem;
    }
  }

  .table-title {
    padding: 1.3rem 0;
  }

  .dialog-image {
    margin-top: -10vh;

    ::v-deep .el-dialog {
      // height: 33.33vw;
      max-width: 70rem;
      max-height: 47.9rem;
    }
  }

  .showmore_content {
    margin-top: 1rem;
    height: 3rem;
    background: white;
  }

  .showmore_font {
    margin-top: 0.5rem;
    height: 2rem;
    font-size: 1.4rem;
    font-family: PingFang SC;
    cursor: pointer;
    color: #1061cc;
    line-height: 2rem;
  }

  .showmore_font:hover {
    color: #0a3d80;
  }

  .content_size {
    margin-left: 2rem !important;
    margin-right: 2rem !important;
  }

  .center_style {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .contact_font {
    width: 11.5rem;
    height: 2rem;
    font-size: 1.4rem;
    line-height: 2rem;
    color: #f2a900;
    padding-left: 7rem;
    padding-top: 1rem;
  }

  .room_describe {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    font-family: 'Source-Sans-Pro-Regular';
    color: #999;
  }

  .room_describe_item {
    font-size: 11px;
    margin-right: 0.5rem;

    div {
      display: inline;
    }
  }

  .room_describe_item:not(:first-child) {
    margin-left: 0.5rem;
  }
  .delayClass{
    color: #FF694B;
  }
}
</style>
<style>
.no-arrow{
  color:#fc6640;
}
.no-arrow:after {
  display: none;
}
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>
 